import formatRoutes from '@/utils/route/formatRoutes';

import HomePage from '@/pages/HomePage';
import LoginCallbackPage from '@/pages/LoginCallbackPage';

import ForbiddenPage from '@/pages/ForbiddenPage';
import UnauthorizedPage from '@/pages/UnauthorizedPage';
import DashboardPage from '@/pages/DashboardPage';
import CustomersPage from '@/pages/CustomersPage';

import AreasPage from '@/pages/OperationalPages/AreasPage';
import AreaDetailsPage from '@/pages/OperationalPages/AreasPage/AreaDetailsPage';

import AccessoriesPage from '@/pages/OperationalPages/AccessoriesPage';

import ConsumablesPage from '@/pages/OperationalPages/InventoryPages/ConsumablesPage';
import CreateConsumablePage from '@/pages/OperationalPages/InventoryPages/ConsumablesPage/CreateConsumablePage';

import ManufacturersPage from '@/pages/OperationalPages/InventoryPages/ManufacturersPage';

import SettingsPage from '@/pages/SettingsPages';
import ConfigsProfilePage from '@/pages/ConfigsProfilePage';
import AccountPage from '@/pages/SettingsPages/AccountPage';

import EmployeesPage from '@/pages/RegistryPages/EmployeesPage';
import CreateEmployeePage from '@/pages/RegistryPages/EmployeesPage/CreateEmployeePage';
import EmployeeDetailsPage from '@/pages/RegistryPages/EmployeesPage/EmployeeDetailsPage';
import EmployeePersonalPage from '@/pages/RegistryPages/EmployeesPage/EmployeeDetailsPage/EmployeePersonalPage';
import EmployeeProfessionalPage from '@/pages/RegistryPages/EmployeesPage/EmployeeDetailsPage/EmployeeProfessionalPage';
import EmployeeContactPage from '@/pages/RegistryPages/EmployeesPage/EmployeeDetailsPage/EmployeeContactPage';

import CompaniesPage from '@/pages/RegistryPages/CompaniesPage';
import CompanyDetailsPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage';
import CompanyGeneralInfoPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanyGeneralInfoPage';
import CompanySettingsPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySettingsPage';

import SuppliersPage from '@/pages/RegistryPages/SuppliersPage';
import SuppliersCreatePage from '@/pages/RegistryPages/SuppliersPage/SuppliersCreatePage';
import SupplierDetailsPage from '@/pages/RegistryPages/SuppliersPage/SupplierDetailsPage';
import SupplierGeneralPage from '@/pages/RegistryPages/SuppliersPage/SupplierDetailsPage/SupplierGeneralPage';
import SupplierAddressesPage from '@/pages/RegistryPages/SuppliersPage/SupplierDetailsPage/SupplierAddressesPage';

import BankAccountsPage from '@/pages/FinancialPages/AccountsPage/BankAccountsPage';
import BankAccountsCreatePage from '@/pages/FinancialPages/AccountsPage/BankAccountsPage/BankAccountsCreatePage';

import PartsPage from '@/pages/OperationalPages/InventoryPages/PartsPage';

import GroupsPage from '@/pages/OperationalPages/InventoryPages/GroupsPage';
import GroupDetailsPage from '@/pages/OperationalPages/InventoryPages/GroupsPage/GroupDetailsPage';

import InventoryPages from '@/pages/OperationalPages/InventoryPages';

import TasksPage from '@/pages/OperationalPages/TasksPage';
import CreateTaskPage from '@/pages/OperationalPages/TasksPage/CreateTaskPage';

import DiagnosticsPage from '@/pages/MovementsPage/DiagnosticsPage';

import LoginPage from '@/pages/LoginPage';
import TaskDetailsPage from '@/pages/OperationalPages/TasksPage/TaskDetailsPage';
import TaskGeneralInfoPage from '@/pages/OperationalPages/TasksPage/TaskDetailsPage/TaskGeneralInfoPage';
import TaskApplicationsPage from '@/pages/OperationalPages/TasksPage/TaskDetailsPage/TaskApplicationsPage';

import QuotationsPage from '@/pages/MovementsPage/QuotationsPage';
import QuotationDetailsPage from '@/pages/MovementsPage/QuotationsPage/QuotationDetailsPage';
import QuotationDetailsItemsPage from '@/pages/MovementsPage/QuotationsPage/QuotationDetailsPage/QuotationDetailsItemsPage';
import QuotationDetailsSuppliersPage from '@/pages/MovementsPage/QuotationsPage/QuotationDetailsPage/QuotationDetailsSuppliersPage';
import QuotationDetailsOffersConfigurationPage from '@/pages/MovementsPage/QuotationsPage/QuotationDetailsPage/QuotationDetailsOffersConfigurationPage';
import QuotationDetailsRequestQuotationPage from '@/pages/MovementsPage/QuotationsPage/QuotationDetailsPage/QuotationDetailsRequestQuotationPage';

import CreateDiagnosticPage from '@/pages/MovementsPage/DiagnosticsPage/CreateDiagnosticPage';
import DiagnosticDetailsPage from '@/pages/MovementsPage/DiagnosticsPage/DiagnosticDetailsPage';

import AccountsPage from '@/pages/FinancialPages/AccountsPage';
import PlanAccountsPage from '@/pages/FinancialPages/AccountsPage/PlanAccountsPage';

import DocumentTypesPage from '@/pages/FinancialPages/AccountsPage/DocumentTypesPage';
import DocumentTypesDetailsPage from '@/pages/FinancialPages/AccountsPage/DocumentTypesPage/DocumentTypesDetailsPage';

import CostCentersPage from '@/pages/FinancialPages/AccountsPage/CostCentersPage';
import InsurersPage from '@/pages/RegistryPages/InsurersPage';
import CreateInsurerPage from '@/pages/RegistryPages/InsurersPage/CreateInsurerPage';
import InsurerDetailsPage from '@/pages/RegistryPages/InsurersPage/InsurerDetailsPage';
import InsurerGeneralPage from '@/pages/RegistryPages/InsurersPage/InsurerDetailsPage/InsurerGeneralPage';
import InsurerContactsPage from '@/pages/RegistryPages/InsurersPage/InsurerDetailsPage/InsurerContactsPage';
import InsurerAddressesPage from '@/pages/RegistryPages/InsurersPage/InsurerDetailsPage/InsurerAddressesPage';
import PaymentConditionsPage from '@/pages/FinancialPages/AccountsPage/PaymentConditionsPage';

import NcmsPage from '@/pages/FiscalPages/NcmPage';
import CreateNcmPage from '@/pages/FiscalPages/NcmPage/CreateNcmPage';
import InvoicePage from '@/pages/FiscalPages/InvoicePage';
import InvoiceEditGeneralPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoiceEditGeneralPage';
import InvoiceNoteItensPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoiceNoteItensNFePage';
import ProfilesPage from '@/pages/SettingsPages/ProfilesPage';
import UsersPage from '@/pages/SettingsPages/UsersPage';
import CreateProfilePage from '@/pages/SettingsPages/ProfilesPage/CreateProfilePage';
import CreateCustomerPage from '@/pages/CustomersPage/CreateCustomerPage';
import CustomerDetailsPage from '@/pages/CustomersPage/CustomerDetailsPage';
import CustomerGeneralInfoPage from '@/pages/CustomersPage/CustomerDetailsPage/CustomerGeneralInfoPage';
import CustomerVehiclesPage from '@/pages/CustomersPage/CustomerDetailsPage/CustomerVehiclesPage';
import CustomerAddressesPage from '@/pages/CustomersPage/CustomerDetailsPage/CustomerAddressesPage';
import CustomerContactsPage from '@/pages/CustomersPage/CustomerDetailsPage/CustomerContactsPage';
import ProfileDetailsPage from '@/pages/SettingsPages/ProfilesPage/ProfileDetailsPage';
import NcmDetailsPage from '@/pages/FiscalPages/NcmPage/NcmDetailsPage';
import StockCorrectionsPage from '@/pages/MovementsPage/StockCorrectionsPage';
import CreateStockCorrectionPage from '@/pages/MovementsPage/StockCorrectionsPage/CreateStockCorrectionPage';
import StockCorrectionDetailsPage from '@/pages/MovementsPage/StockCorrectionsPage/StockCorrectionDetailsPage';
import CreatePartPage from '@/pages/OperationalPages/InventoryPages/PartsPage/CreatePartPage';
import PartDetailsPage from '@/pages/OperationalPages/InventoryPages/PartsPage/PartDetailsPage';
import PartGeneralInfoPage from '@/pages/OperationalPages/InventoryPages/PartsPage/PartDetailsPage/PartGeneralInfoPage';
import PartStockPage from '@/pages/OperationalPages/InventoryPages/PartsPage/PartDetailsPage/PartStockPage';
import WorkorderConfigurationPage from '@/pages/SettingsPages/WorkorderConfigurationPage';
import CompanyWorkorderSettingsPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySettingsPage/CompanyWorkorderSettingsPage';
import HelpCenterHomePage from '@/pages/HelpCenterPages/HelpCenterHomePage';
import HelpCenterHelpAreaPage from '@/pages/HelpCenterPages/HelpCenterHelpAreaPage';
import HelpCenterHelpItemPage from '@/pages/HelpCenterPages/HelpCenterHelpItemPage';
import CompanyWorkorderTagsPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySettingsPage/CompanyWorkorderTagsPage';
import WorkOrdersPage from '@/pages/MovementsPage/WorkOrdersPage';

import SchedulePage from '@/pages/SchedulePage';

import WorkOrderDetailsPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderDetailsPage';

import ShippingOptionsPage from '@/pages/CRMPage/ShippingOptionsPage';
import SearchQuestionnairePage from '@/pages/CRMPage/SearchQuestionnairePage';
import SearchQuestionnaireCreatePage from '@/pages/CRMPage/SearchQuestionnairePage/SearchQuestionnaireCreatePage';
import WorkOrderGeneralInfoPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderDetailsPage/GeneralInfoPage';
import WorkOrderPartsAndTasksPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderDetailsPage/PartsAndTasksPage';
import WorkOrderFinancialPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderDetailsPage/FinancialPage';
import ShippingOptionsManager from '@/pages/CRMPage/ShippingOptionsPage/ShippingOptionsManager';
import ConsumableDetailsPage from '@/pages/OperationalPages/InventoryPages/ConsumablesPage/ConsumableDetailsPage';
import ConsumableGeneralInfoPage from '@/pages/OperationalPages/InventoryPages/ConsumablesPage/ConsumableDetailsPage/ConsumableGeneralInfoPage';
import CompanyPriceCompositionPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySettingsPage/CompanyPriceCompositionPage';
import PartsConfigurationPage from '@/pages/SettingsPages/PartsConfigurationPage';
import ConsumableStockPage from '@/pages/OperationalPages/InventoryPages/ConsumablesPage/ConsumableDetailsPage/ConsumableStockPage';
import BillToPayPage from '@/pages/FinancialPages/BillToPayPage';
import ReleaseBillToPayPage from '@/pages/FinancialPages/BillToPayPage/ReleasesPage';
import GroupingsBillToPayPage from '@/pages/FinancialPages/BillToPayPage/GroupingPage';
import ReleasesCreatePage from '@/pages/FinancialPages/BillToPayPage/ReleasesPage/ReleasesCreatePage';
import BillToReceivePage from '@/pages/FinancialPages/BillToReceivePage';
import ReleaseBillToReceivePage from '@/pages/FinancialPages/BillToReceivePage/ReleasesPage';
import ReleasesBillToReceiveCreatePage from '../pages/FinancialPages/BillToReceivePage/ReleasesPage/ReleasesCreatePage/index';
import GroupingsBillToReceivePage from '@/pages/FinancialPages/BillToReceivePage/GroupingPage';
import InventoryDetailsPage from '@/pages/MovementsPage/InventoryPage/InventoryDetailsPage';
import InventoriesPage from '@/pages/MovementsPage/InventoryPage';
import CashMovementPage from '@/pages/FinancialPages/CashMovementPage';
import DirectSalePage from '@/pages/MovementsPage/DirectSalePage';
import DirectSaleCreatePage from '@/pages/MovementsPage/DirectSalePage/DirectSaleCreatePage';
import DirectSaleDetailsPage from '@/pages/MovementsPage/DirectSalePage/DirectSaleDetailsPage';
import DirectSaleGeneralInfoPage from '@/pages/MovementsPage/DirectSalePage/DirectSaleDetailsPage/DirectSaleGeneralInfoPage';
import FinancialDirectSalePage from '@/pages/MovementsPage/DirectSalePage/DirectSaleDetailsPage/FinancialDirectSalePage';
import PurchasesPage from '@/pages/MovementsPage/PurchasesPage';
import PurchasesReleasesCreatePage from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/ReleasesCreatePage';
import PurchasesReleasesPage from '@/pages/MovementsPage/PurchasesPage/ReleasesPage';
import PurchaseDetailsPage from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/PurchaseDetailsPage';
import PurchaseGeneralInfoPage from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/PurchaseDetailsPage/PurchaseGeneralInfoPage';
import PurchaseTaxesPage from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/PurchaseDetailsPage/PurchaseTaxesPage';
import PurchaseItemsPurchasePage from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/PurchaseDetailsPage/PurchaseItemsPurchasePage';
import PurchaseReturnPage from '@/pages/MovementsPage/PurchaseReturnPage';
import PurchasingGroupingPage from '@/pages/MovementsPage/PurchasingGroupingPage';
import InformativePage from '@/pages/InformativePage';
import CreateInformativePage from '@/pages/InformativePage/CreateInformativePage';
import InformativeDetailsPage from '@/pages/InformativePage/InformativeDetailsPage';
import CompanyCustomTermsPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanyCustomTermsPage';
import NotificationsPage from '@/pages/NotificationsPage';
import NotificationsCreatePage from '@/pages/NotificationsPage/NotificationsCreatePage';
import DeliveryOfMaterialsPage from '@/pages/MovementsPage/DeliveryOfMaterialsPage';
import DeliverMaterialCreatePage from '@/pages/MovementsPage/DeliveryOfMaterialsPage/DeliverMaterialCreatePage';
import ReturnMaterialCreatePage from '@/pages/MovementsPage/DeliveryOfMaterialsPage/ReturnMaterialCreatePage';
import InvoiceNFPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage';
import MovementReportsPage from '@/pages/Reports/MovementReportsPage';
import MovementWorkOrdersReportsPage from '@/pages/Reports/MovementReportsPage/MovementWorkOrdersReportsPage';
import DailyMovementReportsPage from '@/pages/Reports/MovementReportsPage/DailyMovementReportsPage';
import MovementDirectSalePage from '@/pages/Reports/MovementReportsPage/MovementDirectSalePage';
import MovementOsXFinancialPage from '@/pages/Reports/MovementReportsPage/MovementOsXFinancialPage';
import MovementDirectSaleXFinancialPage from '@/pages/Reports/MovementReportsPage/MovementDirectSaleXFinancialPage';
import MovementCustomerWithoutMovementPage from '@/pages/Reports/MovementReportsPage/MovementCustomerWithoutMovementPage';

import ReportsPurchasesPage from '@/pages/Reports/ReportsPurchasesPage';
import PurchasesReportsPage from '@/pages/Reports/ReportsPurchasesPage/PurchasesReportsPage';
import ReturnedPurchasesReportsPage from '@/pages/Reports/ReportsPurchasesPage/ReturnedPurchasesReportsPage';
import PurchasesQuotationPage from '@/pages/Reports/ReportsPurchasesPage/PurchasesQuotationPage';
import PurchasesAbcCurvePage from '@/pages/Reports/ReportsPurchasesPage/PurchasesAbcCurvePage';

import StockReportsPage from '@/pages/Reports/StockReportsPage';
import ABCAnalysisPage from '@/pages/Reports/StockReportsPage/ABCAnalysisPage';
import StockDeliveryOfMaterialsPage from '@/pages/Reports/StockReportsPage/StockDeliveryOfMaterialsPage';
import ConsolidatedPage from '@/pages/Reports/StockReportsPage/ConsolidatedPage';
import MinimumStockPage from '@/pages/Reports/StockReportsPage/MinimumStockPage';

import FinancialReportsPage from '@/pages/Reports/FinancialReportsPage';
import FinancialBillsToPayPage from '@/pages/Reports/FinancialReportsPage/FinancialBillsToPayPage';
import ForecastPayablePage from '@/pages/FinancialPages/BillToPayPage/ForecastPayablePage';
import ForecastPayableCreatePage from '@/pages/FinancialPages/BillToPayPage/ForecastPayablePage/ForecastPayableCreatePage';
import FinancialBillsToReceivePage from '@/pages/Reports/FinancialReportsPage/FinancialBillsToReceivePage';
import FinancialBalancetePage from '@/pages/Reports/FinancialReportsPage/FinancialBalancetePage';
import FinancialCashFlowPage from '@/pages/Reports/FinancialReportsPage/FinancialCashFlowPage';
import FinancialDrePage from '@/pages/Reports/FinancialReportsPage/FinancialDrePage';

import CommissionReportsPage from '@/pages/Reports/CommissionReportsPage';
import CommissionByMovimentsPage from '@/pages/Reports/CommissionReportsPage/CommissionByMovimentsPage';
import CommissionByFinancialPage from '@/pages/Reports/CommissionReportsPage/CommissionByFinancialPage';

import ProductiveReportsPage from '@/pages/Reports/ProductiveReportsPage';
import ProductiveHoursSoldPage from '@/pages/Reports/ProductiveReportsPage/ProductiveHoursSoldPage';
import ProductiveHoursCostPage from '@/pages/Reports/ProductiveReportsPage/ProductiveHoursCostPage';

import ManagerialReportsPage from '@/pages/Reports/ManagerialReportsPage';
import ManagerialInvoicingPage from '@/pages/Reports/ManagerialReportsPage/ManagerialInvoicingPage';
import ManagerialCostPage from '@/pages/Reports/ManagerialReportsPage/ManagerialCostPage';

import FiscalReport from '@/pages/Reports/FiscalReportsPage';
import FiscalInvoicePage from '@/pages/Reports/FiscalReportsPage/FiscalInvoicePage';
import SalesByCST from '@/pages/Reports/FiscalReportsPage/SalesByCST';

import PurchaseCreateItemPurchase from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/PurchaseDetailsPage/PurchaseCreateItemPurchase';

import PartApplicationPage from '@/pages/OperationalPages/InventoryPages/PartsPage/PartDetailsPage/PartApplicationPage';

import InvoiceAdditionalDataPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoiceAdditionalDataPage';

import InvoiceRecipientPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoiceRecipientPage';
import SearchPartsPage from '@/pages/SearchPartsPage';
import EmployeeAddressPage from '@/pages/RegistryPages/EmployeesPage/EmployeeDetailsPage/EmployeeAddressPage';
import InvoiceNFeDetailsPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoiceNFeDetailsPage';
import InvoiceNFSeDetailsPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoiceNFSeDetailsPage';
import CompanyInvoicePage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanyInvoicePage';
import InvoicePaymentConditionGeneralPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoicePaymentConditionGeneralPage';
import SearchPartDetailsPage from '@/pages/SearchPartsPage/SearchPartDetailsPage';
import SearchPartStockPage from '@/pages/SearchPartsPage/SearchPartDetailsPage/SearchPartStockPage';
import ReleasesBillToReceiveDetailPage from '@/pages/FinancialPages/BillToReceivePage/ReleasesPage/ReleasesDetailPage';
import InvoiceTransportPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoiceTransportPage';

import SupplierContactsPage from '@/pages/RegistryPages/SuppliersPage/SupplierDetailsPage/SupplierContactsPage';
import ConsumablesLastPurchasesPage from '@/pages/OperationalPages/InventoryPages/ConsumablesPage/ConsumableDetailsPage/ConsumablesLastPurchasesPage';
import LastPurchasesPage from '@/pages/OperationalPages/InventoryPages/PartsPage/PartDetailsPage/LastPurchasesPage';
import SearchPartReplacementPartsPage from '@/pages/SearchPartsPage/SearchPartDetailsPage/SearchPartReplacementPartsPage';
import SearchPartApplicationPage from '@/pages/SearchPartsPage/SearchPartDetailsPage/SearchPartApplicationPage';
import SearchPartlatestPartPurchasesPage from '@/pages/SearchPartsPage/SearchPartDetailsPage/SearchPartlatestPartPurchasesPage';
import VehiclesHistoryPage from '@/pages/HistoryPage/VehiclesHistoryPage';
import PurchaseDetailItemPurchase from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/PurchaseDetailsPage/PurchaseDetailItemPurchase';
import VehicleHistoryDetailPage from '@/pages/HistoryPage/VehiclesHistoryPage/VehicleHistoryDetailPage';
import PurchaseImportPage from '@/pages/MovementsPage/PurchaseImportPage';
import ConfirmImportPurchasePage from '@/pages/MovementsPage/PurchaseImportPage/ConfirmImportPurchasePage';
import PartReplacementPartsPage from '@/pages/OperationalPages/InventoryPages/PartsPage/PartDetailsPage/PartReplacementPartsPage';
import BankingEntryPage from '@/pages/FinancialPages/BankingEntryPage';
import BankingEntryCreatePage from '@/pages/FinancialPages/BankingEntryPage/BankingEntryCreatePage';
import WorkOrderObservationsPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderDetailsPage/ObservationsPage';
import CommissionsPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderDetailsPage/CommissionsPage';
import CustomerSettingsPage from '@/pages/SettingsPages/CustomerSettingsPage';
import CustomerListPage from '@/pages/CustomersPage/CustomerListPage';
import InvoiceNoteItemsSelectPartForm from '@/components/Fiscal/Invoice/InvoiceForms/InvoiceNoteItemsGeneralForm/InvoiceNoteItemsGeneralTable/InvoiceNoteItemsSelectPartForm';
import CompanyReportPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanyReportPage';
import ReleasesDetailsPage from '@/pages/FinancialPages/BillToPayPage/ReleasesPage/ReleasesDetailsPage';
import WorkOrderMailPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderDetailsPage/MailPage';

import BankAccountsDetailsPage from '@/pages/FinancialPages/AccountsPage/BankAccountsPage/BankAccountsDetailsPage';
import BankAccountsGeneralPage from '@/pages/FinancialPages/AccountsPage/BankAccountsPage/BankAccountsDetailsPage/BankAccountsGeneralPage';
import BankAccountsContactPage from '@/pages/FinancialPages/AccountsPage/BankAccountsPage/BankAccountsDetailsPage/BankAccountsContactsPage';
import BankingEntryDetailsPage from '@/pages/FinancialPages/BankingEntryPage/BankingEntryDetailsPage';
import ForecastPayableDetailsPage from '@/pages/FinancialPages/BillToPayPage/ForecastPayablePage/ForecastPayableDetailsPage';
import WorkOrderImportPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderImportPage';
import ManagementChartsPage from '@/pages/ManagementChartsPage';
import FinancialChartsPage from '@/pages/ManagementChartsPage/FinancialChartsPage';
import CreateCompanyPage from '@/pages/RegistryPages/CompaniesPage/CreateCompanyPage';
import WorkorderChecklistPage from '@/pages/MovementsPage/WorkOrdersPage/WorkorderChecklistPage';
import WorkorderChecklistDamagePage from '@/pages/MovementsPage/WorkOrdersPage/WorkorderChecklistPage/ChecklistDamagePage';
import WorkorderChecklistImagesPage from '@/pages/MovementsPage/WorkOrdersPage/WorkorderChecklistPage/ChecklistImagesPage';
import WorkorderChecklistAccessoriesPage from '@/pages/MovementsPage/WorkOrdersPage/WorkorderChecklistPage/ChecklistAccessoriesPage';
import WorkorderChecklistQuickChecklistPage from '@/pages/MovementsPage/WorkOrdersPage/WorkorderChecklistPage/ChecklistQuickChecklistPage';
import WorkorderChecklistComplementItemsPage from '@/pages/MovementsPage/WorkOrdersPage/WorkorderChecklistPage/ChecklistComplementItemsPage';
import WorkorderChecklistFutureServicesPage from '@/pages/MovementsPage/WorkOrdersPage/WorkorderChecklistPage/ChecklistFutureServices';

import NotFoundPage from '@/pages/NotFoundPage';
import WorkorderChecklistRequestedServicesPage from '@/pages/MovementsPage/WorkOrdersPage/WorkorderChecklistPage/ChecklistRequestedServicesPage';
import MovementsSettingsPage from '@/pages/SettingsPages/MovementsSettingsPage';
import CrmSettingsPage from '@/pages/SettingsPages/CrmSettingsPage';

import PurchaseFinancialPage from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/PurchaseDetailsPage/PurchaseFinancialPage';
import SaleChartsPage from '@/pages/ManagementChartsPage/SaleChartsPage';
import InvoiceNFCeDetailsPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoiceNFCeDetailsPage';
import InvoicingChartsPage from '@/pages/ManagementChartsPage/InvoicingChartsPage';
import BankAccountConfigBankSlipPage from '@/pages/FinancialPages/AccountsPage/BankAccountsPage/BankAccountsDetailsPage/BankAccountConfigBankSlipPage';
import RegistrationsSettingsPage from '@/pages/SettingsPages/RegistrationsSettingsPage';
import SupplierCreditPage from '@/pages/RegistryPages/SuppliersPage/SupplierDetailsPage/SupplierCreditPage';
import SupplierReturnedItemsPage from '@/pages/RegistryPages/SuppliersPage/SupplierDetailsPage/SupplierReturnedItemsPage';
import WorkOrderCalendarPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderCalendarPage';
import QuotationRequestPage from '@/pages/QuotationRequestPage';
import PasswordSettingsPage from '@/pages/SettingsPages/PasswordSettingsPage';
import EmployeeCommissionsPage from '@/pages/MovementsPage/EmployeeCommissionsPage';
import ReturnDetailsPage from '@/pages/MovementsPage/DeliveryOfMaterialsPage/ReturnDetailsPage';
import DeliveryDetailsPage from '@/pages/MovementsPage/DeliveryOfMaterialsPage/DeliveryDetailsPage';
import EmailSettingsPage from '@/pages/SettingsPages/EmailSettingsPage';
import EmailSettingsProfilePage from '@/pages/SettingsPages/EmailSettingsProfilePage';
import InvoiceEditNoteItemsSelectPartForm from '@/components/Fiscal/Invoice/InvoiceForms/InvoiceNoteItemsGeneralForm/InvoiceNoteItemsGeneralTable/InvoiceEditNoteItemsSelectPartForm';
import PurchaseDataFreightPage from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/PurchaseDetailsPage/PurchaseDataFreightPage';
import PurchasingPartsLinkPage from '@/pages/MovementsPage/PurchasingPartsLinkPage';
import ConfirmImportPurchaseCsvPage from '@/pages/MovementsPage/PurchasingPartsLinkPage/ConfirmImportPurchaseCsvPage';
import PurchaseGroupingsPage from '@/pages/MovementsPage/PurchasesPage/ReleasesPage/PurchaseDetailsPage/PurchaseGroupingsPage';
import InvoiceCcePage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoiceCcePage';
import WorkOrderViewPublicPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderViewPublicPage';
import WorkOrderInvoicePage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderDetailsPage/InvoicePage';
import BankSlipPage from '@/pages/FinancialPages/BankSlipPage';
import SettingsFiscalPage from '@/pages/SettingsPages/SettingsFiscalPage';
import ChecklistReport from '@/pages/Public/Reports/ChecklistReport';
import ReportSettingsPage from '@/pages/SettingsPages/ReportSettingsPage';
import PrivateQuatationReportsItemsByQuotation from '@/pages/Reports/PrivateReports/Quotations/ItemsByQuotation';
import PrivateQuatationReportsSupplierWinners from '@/pages/Reports/PrivateReports/Quotations/SupplierWinners';
import PrivateReportMaterialDelivery from '@/pages/Reports/PrivateReports/MaterialDeliveryReturn/MaterialDelivery';
import PrivateReportMaterialReturn from '@/pages/Reports/PrivateReports/MaterialDeliveryReturn/MaterialReturn';
import AccountValidatePage from '@/pages/Public/AccountValidate';
import PrivateReportChecklistEmpty from '@/pages/Reports/PrivateReports/ChecklistEmpty';
import PrivateQuatationReportsItemsSuppliers from '@/pages/Reports/PrivateReports/Quotations/ItemsSuppliers';
import { InvoiceType } from '@/core/domain/invoice/invoices/invoices.enums';
import ViewCalendarAccountPayablePage from '@/pages/FinancialPages/BillToPayPage/ViewCalendarAccountPayablePage';
import ViewCalendarAccountReceivablePage from '@/pages/FinancialPages/BillToReceivePage/ViewCalendarAccountReceivablePage';
import PrivacyPolicyPage from '@/pages/Public/PrivacyPolicy';
import InvoiceNfsInstallmentsPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoiceNfsInstallmentsPage';
import InvoiceNfsDeductionsPage from '@/pages/FiscalPages/InvoicePage/InvoiceNFPage/InvoiceNfsDeductionsPage';
import InvoiceNoteItemServiceForm from '@/components/Fiscal/Invoice/InvoiceForms/InvoiceNoteItemsGeneralForm/InvoiceNoteItemsGeneralTable/InvoiceNoteItemServiceForm';
import ReportCommissionByEmployeePage from '@/pages/Reports/PrivateReports/Commissions/CommissionByEmployeePage';
import ShippingOptionsCreatePage from '@/pages/CRMPage/ShippingOptionsPage/ShippingOptionsCreatePage';
import PrivateInventory from '@/pages/Reports/PrivateReports/Inventory';
import CrmQuizPage from '@/pages/Public/CrmQuizPage';
import ScheduleKanbanPage from '@/pages/SchedulePage/ScheduleKanbanPage';
import ManifestationRecipientPage from '@/pages/FiscalPages/InvoicePage/ManifestationRecipientPage';
// import VehicleHistoryReportPage from '@/pages/HistoryPage/VehiclesHistoryPage/VehicleHistoryReportPage';
import Authorities from '@/types/Authority';
import EmailHistoryPage from '@/pages/HistoryPage/EmailHistoryPage';
import ExpiredPage from '@/pages/ExpiredPage';
import WhatsappTemplates from '@/pages/SettingsPages/WhatsappTemplates';
import PartsReport from '@/pages/Public/Reports/PartsReport';
import PrivateReportMechanicsRecord from '@/pages/Reports/PrivateReports/MechanicsRecord';
import InspectionRecord from '@/pages/Reports/PrivateReports/InspectionRecord';
import PrivateReportProductTags from '@/pages/Reports/PrivateReports/ProductTags';
import SintegraPage from '@/pages/FiscalPages/InvoicePage/SintegraPage';
import PageRedirect from '@/components/_common/PageRedirect';
import InvoiceCFeGeneralDataPage from '@/pages/FiscalPages/InvoicePage/InvoiceCFePage/GeneralDataPage';
import InvoiceCFeItensPage from '@/pages/FiscalPages/InvoicePage/InvoiceCFePage/ItensPage';
import InvoiceCFePaymentsMethodPage from '@/pages/FiscalPages/InvoicePage/InvoiceCFePage/PaymentsMethodsPage';
import InvoiceCFeRecipientPage from '@/pages/FiscalPages/InvoicePage/InvoiceCFePage/RecipientPage';
import InvoiceCFeListPage from '@/pages/FiscalPages/InvoiceCFePage';
import CompanyCouponPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanyCouponPage';
import CompanyProfitCostCompositionPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySettingsPage/CompanyProfitCostCompositionPage';
import KitsPage from '@/pages/OperationalPages/KitsPage';
import KitsCreatePage from '@/pages/OperationalPages/KitsPage/KitsCreatePage';
import KitsDetailPage from '@/pages/OperationalPages/KitsPage/KitDetailPage';
import CompanyFinancialSettingsPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySettingsPage/CompanyFinancialSettingsPage';
import DirectSaleIndicatorsPage from '@/pages/MovementsPage/DirectSalePage/DirectSaleIndicatorsPage';
import ScheduleAccompanimentPage from '@/pages/SchedulePage/ScheduleAccompanimentPage';
import CompanySintegraPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySintegraPage';
import PrivateReportCustomerTags from '@/pages/Reports/PrivateReports/CustomerTags';
import CustomerIndicatorPage from '@/pages/CustomersPage/CustomerIndicatorPage';
import CustomerChecklistReport from '@/pages/Public/Reports/ChecklistReport/costumer';
import PrivateReportPurchaseItemTags from '@/pages/Reports/PrivateReports/PurchaseItemTags';
import TransportPage from '@/pages/RegistryPages/TransportPage';
import WorkOrderIndicatorsPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderIndicatorsPage';
import { Redirect } from 'react-router-dom';
import BillToPayReleasesAttachmentPage from '@/pages/FinancialPages/BillToPayPage/ReleasesPage/ReleasesDetailsPage/ReleasesAttachmentPage';
import BillToReceiveReleasesAttachmentPage from '@/pages/FinancialPages/BillToReceivePage/ReleasesPage/ReleasesDetailPage/ReleasesAttachmentPage';
import TagsWorkOrderPage from '@/pages/SettingsPages/TagsWorkOrderPage';
import MovementFutureServicesPage from '@/pages/Reports/MovementReportsPage/MovementFutureServicesPage';
import StatusWorkOrderPage from '@/pages/SettingsPages/StatusWorkOrderPage';
import CouponsPage from '@/pages/FiscalPages/CouponsPage';
import PublicWorkOrderComplement from '@/pages/Public/WorkOrderComplement';
import BankConciliationPage from '@/pages/FinancialPages/BankConciliationPage';
import DisableNumberingRangePage from '@/pages/FiscalPages/InvoicePage/DisableNumberingRangePage';
import LinkingAccountsPage from '@/pages/SettingsPages/LinkinAccountsPage';
import AmazonLoginPage from '@/pages/CallbackPage/AmazonLogin';
import FunctionsPage from '@/pages/RegistryPages/FunctionsPage';
import FinancialConfigurationPage from '@/pages/SettingsPages/FinancialConfigurationPage';
import FinancialBankSlip from '@/pages/Reports/FinancialReportsPage/FinancialBankSlipPage';
import PrivateReportReceiptRecord from '@/pages/Reports/PrivateReports/ReceiptRecord';
import EmailSettingsCrmPage from '@/pages/SettingsPages/EmailSettingsCrmPage';
import MovementVehicleWithoutMovementPage from '@/pages/Reports/MovementReportsPage/MovementVehicleWithoutMovementPage';
import FinancialSettingsPage from '@/pages/SettingsPages/FinancialSettingsPage';
import WorkOrderMigrationConsultListPage from '@/pages/MovementsPage/WorkOrdersPage/WorkOrderMigrationConsultListPage';
import CompanyListPage from '@/pages/RegistryPages/CompaniesPage/CompanyListPage';
import CompanyBankSlipPage from '@/pages/RegistryPages/CompaniesPage/CompanyBankSlipPage';
import CompanyIntegrationsPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySettingsPage/CompanyIntegrationsPage';
import IntegrationsPage from '@/pages/SettingsPages/IntegrationsPage';
import VehiclePlateHistoryPage from '@/pages/HistoryPage/VehiclesHistoryPage/VehiclePlateHistoryPage';
import StockTransferPage from '@/pages/MovementsPage/StockTransferPage';
import StockTransferCreatePage from '@/pages/MovementsPage/StockTransferPage/StockTransferCreatePage';
import StockTransferDetailsPage from '@/pages/MovementsPage/StockTransferPage/StockTransferDetailsPage';
import CompanyPurchasesPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySettingsPage/CompanyPurchasesPage';
import ChecklistObservationsPage from '@/pages/MovementsPage/WorkOrdersPage/WorkorderChecklistPage/ChecklistObservationsPage';
import MovementOsXInvoicePage from '@/pages/Reports/MovementReportsPage/MovementOsXInvoicePage';
import ReleasesBillToReceiveMigrationConsultPage from '@/pages/FinancialPages/BillToReceivePage/ReleasesBillToReceiveMigrationConsultPage';
import ReleasesBillToPayMigrationConsultPage from '@/pages/FinancialPages/BillToPayPage/ReleasesBillToPayMigrationConsultPage';
import ManagerialAuditPage from '@/pages/Reports/ManagerialReportsPage/ManagerialAuditPage';
import CompanyResourceLimitationPeriodsPage from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySettingsPage/CompanyResourceLimitationPeriodsPage';
import TagsDirectSalePage from '@/pages/SettingsPages/TagsDirectSalePage';
import CompanyPortoScheduleServices from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySettingsPage/CompanyPortoScheduleServices';
import BankSlipReportPublic from '@/pages/Public/Reports/BankSlipReport';
import MovementAbcCurvePage from '@/pages/Reports/MovementReportsPage/MovementAbcCurvePage';
import YardManagementReportPage from '@/pages/Reports/YardManagementReportPage';
import SpedPage from '@/pages/FiscalPages/SpedPage';
import SpedDocumentsPage from '@/pages/FiscalPages/SpedPage/SpedDocumentsPage';
import SpedConfigPage from '@/pages/FiscalPages/SpedPage/SpedConfigPage';
import SpedDocumentDetailPage from '@/pages/FiscalPages/SpedPage/SpedDocumentsPage/SpedDocumentDetailPage';
import CompanyBoschCoreCredentials from '@/pages/RegistryPages/CompaniesPage/CompanyDetailsPage/CompanySettingsPage/CompanyBoschCoreCredentials';
import ProspectingPage from '@/pages/CRMPage/ProspectingPage';
import PartsLabelPrintPage from '@/pages/Reports/PrivateReports/PartsLabelPrintPage';
import PublicWorkOrderReviewEtiquette from '@/pages/Public/WorkOrderReviewEtiquette';
import ActivationHashPage from '@/pages/Public/Companies/ActivationHashPage';
import ProspectingMigratedWorkOrders from '@/pages/CRMPage/ProspectingMigratedWorkOrders';

const isAppPortocar = process.env.REACT_APP_APPLICATION === 'PORTOCAR';

const routes = [
  {
    key: 'home',
    groupKey: 'public',
    exact: true,
    component: HomePage,
    name: 'Home',
  },
  // {
  //   key: 'register',
  //   groupKey: 'public',
  //   exact: true,
  //   component: RegisterPage,
  //   name: 'Register',
  // },
  {
    key: 'login',
    groupKey: 'public',
    exact: true,
    component: LoginPage,
    name: 'login.pageTitle',
  },
  {
    key: 'external/quotation/:guid',
    groupKey: 'public',
    exact: true,
    component: QuotationRequestPage,
    name: 'quotations.request',
  },
  {
    key: 'external/workOrderQRCode/:guid',
    groupKey: 'public',
    exact: true,
    component: WorkOrderViewPublicPage,
    name: 'workOrders.public.workOrder.view',
  },
  {
    key: 'app',
    routes: [
      {
        key: 'dashboard',
        permissions: [
          Authorities.MOVIMENTATION_WORKORDER_VIEW,
          Authorities.REGISTER_EMPLOYEE_VIEW,
        ],
        exact: true,
        component: DashboardPage,
        name: 'layout.menu.dashboard',
        menu: {
          icon: <></>,
        },
      },

      {
        key: 'searchParts',
        exact: true,
        component: SearchPartsPage,
        name: 'layout.overview.searchParts',
        permissions: [Authorities.VIEW_PARTS_CONSULTATION],
        routes: [
          {
            key: ':partId',
            exact: true,
            component: SearchPartDetailsPage,
            name: 'layout.overview.searchParts',
            routes: [
              {
                key: 'stock',
                component: SearchPartStockPage,
                exact: true,
                name: 'layout.menu.operational.inventory.parts.details.stock',
                permissions: [Authorities.VIEW_PARTS_STOCKS],
              },
              {
                key: 'application',
                component: SearchPartApplicationPage,
                exact: true,
                name: 'layout.menu.operational.inventory.parts.details.application',
              },
              {
                key: 'replacementParts',
                component: SearchPartReplacementPartsPage,
                exact: true,
                name: 'layout.menu.operational.inventory.parts.details.replacementParts',
              },
              {
                key: 'latestPartPurchases',
                component: SearchPartlatestPartPurchasesPage,
                exact: true,
                name: 'layout.menu.operational.inventory.parts.details.latestPartPurchases',
                permissions: [Authorities.VIEW_PARTS_LAST_PURCHASES],
              },
            ],
          },
        ],
      },

      {
        key: 'customers',
        exact: true,
        component: CustomersPage,
        name: 'layout.menu.customers',
        menu: {
          icon: <></>,
        },
        routes: [
          {
            key: 'list',
            exact: true,
            component: CustomerListPage,
            name: 'layout.menu.customers',
            menu: {
              icon: <></>,
            },
            permissions: [Authorities.REGISTER_CUSTOMER_VIEW],
          },
          {
            key: 'indicators',
            exact: true,
            component: CustomerIndicatorPage,
            name: 'layout.menu.indicators',
            permissions: [Authorities.REGISTER_CUSTOMER_VIEW],
          },
          {
            key: 'crm',
            name: 'layout.menu.crm',
            component: () => null,
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'shippingOptions',
                permissions: [Authorities.CRM_SENDOPTION_VIEW],
                exact: true,
                component: ShippingOptionsPage,
                name: 'layout.menu.crm.shippingOptions',
                menu: {
                  icon: <></>,
                },
                routes: [
                  {
                    key: 'create',
                    component: ShippingOptionsCreatePage,
                    permissions: [Authorities.CRM_SENDOPTION_CREATE],
                    name: 'layout.menu.crm.shippingOptions',
                  },
                  {
                    key: ':sendOptionId',
                    component: ShippingOptionsManager,
                    permissions: [Authorities.CRM_SENDOPTION_UPDATE],
                    name: 'layout.menu.crm.shippingOptions',
                  },
                ],
              },
              {
                key: 'searchQuestionnaire',
                permissions: [Authorities.CRM_QUESTION_VIEW],
                exact: true,
                component: SearchQuestionnairePage,
                name: 'layout.menu.crm.searchQuestionnaire',
                menu: {
                  icon: <></>,
                },
                routes: [
                  {
                    key: 'create',
                    component: SearchQuestionnaireCreatePage,
                    permissions: [Authorities.CRM_QUESTION_CREATE],
                    name: 'layout.menu.crm.searchQuestionnaire.create',
                  },
                  {
                    key: ':quizId',
                    component: SearchQuestionnaireCreatePage,
                    permissions: [Authorities.CRM_QUESTION_UPDATE],
                    name: 'layout.menu.crm.searchQuestionnaire.details',
                    routes: [
                      {
                        key: 'general',
                        permissions: [Authorities.CRM_QUESTION_UPDATE],
                        component: () => null,
                        name: 'layout.menu.crm.searchQuestionnaire',
                      },
                      {
                        key: 'syntheticAnalysis',
                        permissions: [Authorities.CRM_QUESTION_UPDATE],
                        component: () => null,
                        name: 'layout.menu.crm.searchQuestionnaire.details.syntheticAnalysis',
                      },
                      {
                        key: 'individualAnalysis',
                        permissions: [Authorities.CRM_QUESTION_UPDATE],
                        component: () => null,
                        name: 'layout.menu.crm.searchQuestionnaire.details.individualAnalysis',
                      },
                    ],
                  },
                ],
              },
              {
                key: 'prospecting',
                exact: true,
                component: ProspectingPage,
                name: 'layout.menu.crm.prospecting',
                hidden: !isAppPortocar,
                menu: {
                  icon: <></>,
                },
                routes: [],
              },
              {
                key: 'prospectingMigratedWorkOrders',
                exact: true,
                component: ProspectingMigratedWorkOrders,
                name: 'layout.menu.crm.prospectingMigratedWorkOrders',
                hidden: !isAppPortocar,
                menu: {
                  icon: <></>,
                },
                routes: [],
              },
            ],
          },
          {
            key: 'create',
            permissions: [Authorities.REGISTER_CUSTOMER_ADD],
            exact: true,
            component: CreateCustomerPage,
            name: 'layout.menu.customers.create',
          },
          {
            key: ':customerId',
            component: CustomerDetailsPage,
            name: 'layout.menu.customers.details',
            routes: [
              {
                key: 'general',
                component: CustomerGeneralInfoPage,
                permissions: [Authorities.REGISTER_CUSTOMER_EDIT],
                name: 'layout.menu.customers.details.generalInfo',
              },
              {
                key: 'addresses',
                permissions: [Authorities.REGISTER_CUSTOMER_EDIT],
                component: CustomerAddressesPage,
                name: 'layout.menu.customers.details.addresses',
              },
              {
                key: 'contacts',
                permissions: [Authorities.REGISTER_CUSTOMER_EDIT],
                component: CustomerContactsPage,
                name: 'layout.menu.customers.details.contacts',
              },
              {
                key: 'vehicles',
                permissions: [Authorities.REGISTER_CUSTOMER_EDIT],
                component: CustomerVehiclesPage,
                name: 'layout.menu.customers.details.vehicles',
              },
            ],
          },
        ],
      },
      {
        key: 'operational',
        name: 'layout.menu.operational',
        component: () => null,
        menu: {
          icon: <></>,
        },
        routes: [
          {
            key: 'inventory',
            permissions: [Authorities.REGISTER_PART_VIEW],
            component: InventoryPages,
            name: 'layout.menu.operational.inventory',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'parts',
                permissions: [Authorities.REGISTER_PART_VIEW],
                component: PartsPage,
                exact: true,
                name: 'layout.menu.operational.inventory.parts',
                routes: [
                  {
                    key: 'create',
                    permissions: [Authorities.REGISTER_PART_ADD],
                    exact: true,
                    component: CreatePartPage,
                    name: 'layout.menu.operational.inventory.parts.create',
                  },
                  {
                    key: ':partId',
                    permissions: [Authorities.REGISTER_PART_VIEW],
                    component: PartDetailsPage,
                    name: 'layout.menu.operational.inventory.parts.details',
                    routes: [
                      {
                        key: 'general',
                        permissions: [Authorities.REGISTER_PART_VIEW],
                        component: PartGeneralInfoPage,
                        name: 'layout.menu.operational.inventory.parts.details.general',
                      },
                      {
                        key: 'stock',
                        permissions: [Authorities.REGISTER_PART_VIEW],
                        component: PartStockPage,
                        name: 'layout.menu.operational.inventory.parts.details.stock',
                      },
                      {
                        key: 'application',
                        permissions: [
                          Authorities.REGISTER_PART_VIEW,
                          Authorities.PART_APPLICATION_READ,
                        ],
                        component: PartApplicationPage,
                        name: 'layout.menu.operational.inventory.parts.details.application',
                      },
                      {
                        key: 'replacementParts',
                        permissions: [
                          Authorities.REGISTER_PART_VIEW,
                          Authorities.PART_REPLACEMENT_READ,
                        ],
                        component: PartReplacementPartsPage,
                        name: 'layout.menu.operational.inventory.parts.details.replacementParts',
                      },
                      {
                        key: 'lastPurchases',
                        permissions: [
                          Authorities.REGISTER_PART_VIEW,
                          Authorities.MOVIMENTATION_PURCHASE_VIEW,
                        ],
                        component: LastPurchasesPage,
                        name: 'layout.menu.operational.inventory.parts.details.lastPurchases',
                      },
                    ],
                  },
                ],
              },
              {
                key: 'consumables',
                permissions: [Authorities.REGISTER_CONSUMABLE_VIEW],
                exact: true,
                component: ConsumablesPage,
                name: 'layout.menu.operational.inventory.consumables',
                routes: [
                  {
                    key: 'create',
                    exact: true,
                    component: CreateConsumablePage,
                    name: 'layout.menu.operational.inventory.consumables.create',
                  },
                  {
                    key: ':consumableId',
                    component: ConsumableDetailsPage,
                    name: 'layout.menu.operational.inventory.consumables.details',
                    routes: [
                      {
                        key: 'general',
                        component: ConsumableGeneralInfoPage,
                        name: 'layout.menu.operational.inventory.consumables.details.general',
                      },
                      {
                        key: 'stock',
                        component: ConsumableStockPage,
                        name: 'layout.menu.operational.inventory.consumables.details.stock',
                      },
                      {
                        key: 'lastPurchases',
                        component: ConsumablesLastPurchasesPage,
                        name: 'layout.menu.operational.inventory.consumables.details.lastConsumablePurchases',
                      },
                    ],
                  },
                ],
              },
              {
                key: 'manufacturers',
                permissions: [Authorities.REGISTER_MANUFACTER_VIEW],
                exact: true,
                component: ManufacturersPage,
                name: 'layout.menu.operational.inventory.manufacturers',
              },
              {
                key: 'groups',
                permissions: [Authorities.REGISTER_GROUP_VIEW],
                exact: true,
                component: GroupsPage,
                name: 'layout.menu.operational.inventory.groups',
                routes: [
                  {
                    key: ':groupId',
                    permissions: [
                      Authorities.REGISTER_GROUP_VIEW,
                      Authorities.REGISTER_GROUP_EDIT,
                    ],
                    component: GroupDetailsPage,
                    name: 'layout.menu.operational.inventory.groups.general',
                  },
                ],
              },
            ],
          },
          {
            key: 'kits',
            exact: true,
            component: KitsPage,
            permissions: [Authorities.KITS_VIEW],
            name: 'layout.menu.operational.kits',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'create',
                permissions: [Authorities.KITS_REGISTRATION],
                exact: true,
                component: KitsCreatePage,
                name: 'layout.menu.operational.kits.create',
              },
              {
                key: ':kitId',
                permissions: [Authorities.KITS_EDIT],
                exact: true,
                component: KitsDetailPage,
                name: 'layout.menu.operational.kits.detail',
              },
            ],
          },
          {
            key: 'tasks',
            permissions: [Authorities.REGISTER_TASK_VIEW],
            component: TasksPage,
            exact: true,
            name: 'layout.menu.operational.tasks',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'create',
                permissons: [Authorities.REGISTER_TASK_ADD],
                exact: true,
                component: CreateTaskPage,
                name: 'layout.menu.operational.tasks.create',
              },
              {
                key: ':taskId',
                permissons: [Authorities.REGISTER_TASK_VIEW],
                component: TaskDetailsPage,
                name: 'layout.menu.operational.tasks.details',
                routes: [
                  {
                    key: 'general',
                    permissons: [Authorities.REGISTER_TASK_VIEW],
                    component: TaskGeneralInfoPage,
                    name: 'layout.menu.operational.tasks.details.general',
                  },
                  {
                    key: 'applications',
                    permissons: [
                      Authorities.REGISTER_TASK_VIEW_APPLICATION,
                      Authorities.REGISTER_TASK_VIEW,
                    ],
                    component: TaskApplicationsPage,
                    name: 'layout.menu.operational.tasks.details.applications',
                  },
                ],
              },
            ],
          },
          {
            key: 'areas',
            permissions: [Authorities.REGISTER_AREA_VIEW],
            exact: true,
            component: AreasPage,
            name: 'layout.menu.operational.areas',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: ':areaId',
                component: AreaDetailsPage,
                name: 'layout.menu.operational.areas.details',
                permissions: [Authorities.REGISTER_AREA_VIEW],
              },
            ],
          },
          {
            key: 'accessories',
            permissions: [Authorities.REGISTER_ACCESSORY_VIEW],
            exact: true,
            component: AccessoriesPage,
            name: 'layout.menu.operational.accessories',
            menu: {
              icon: <></>,
            },
          },
        ],
      },
      {
        key: 'registry',
        name: 'layout.menu.registry',
        component: () => null,
        menu: {
          icon: <></>,
        },
        routes: [
          {
            key: 'companies',
            permissions: [Authorities.REGISTER_COMPANY_VIEW],
            exact: true,
            component: CompaniesPage,
            name: 'layout.menu.registry.companies',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'list',
                permissions: [Authorities.REGISTER_COMPANY_VIEW],
                component: CompanyListPage,
                name: 'layout.menu.registry.companies',
                exact: true,
              },
              {
                key: 'bankSlips',
                permissions: [Authorities.REGISTER_COMPANY_BANK_SLIP_VIEW],
                component: CompanyBankSlipPage,
                name: 'layout.menu.registry.companies..contract.bankSlips',
                exact: true,
              },
              {
                key: 'create',
                permissions: [Authorities.REGISTER_COMPANY_ADD],
                exact: true,
                component: CreateCompanyPage,
                name: 'layout.menu.registry.companies.create',
              },
              {
                key: ':companyId',
                component: CompanyDetailsPage,
                name: 'layout.menu.registry.companies.details',
                routes: [
                  {
                    key: 'general',
                    permissions: [Authorities.REGISTER_COMPANY_VIEW],
                    component: CompanyGeneralInfoPage,
                    name: 'layout.menu.registry.companies.general',
                  },
                  {
                    key: 'settings',
                    component: CompanySettingsPage,
                    permissions: [Authorities.REGISTER_COMPANY_VIEW],
                    name: 'layout.menu.registry.companies.settings',
                    routes: [
                      {
                        key: 'workorder',
                        permissions: [Authorities.REGISTER_COMPANY_VIEW],
                        component: CompanyWorkorderSettingsPage,
                        name: 'layout.overview.budgets',
                      },
                      {
                        key: 'priceComposition',
                        permissions: [Authorities.REGISTER_COMPANY_VIEW],
                        component: CompanyPriceCompositionPage,
                        name: 'layout.menu.registry.companies.settings.priceComposition',
                      },
                      {
                        key: 'profitCostComposition',
                        permissions: [Authorities.REGISTER_COMPANY_VIEW],
                        component: CompanyProfitCostCompositionPage,
                        name: 'layout.menu.registry.companies.settings.profitCostComposition',
                      },
                      {
                        key: 'tags',
                        permissions: [Authorities.REGISTER_COMPANY_VIEW],
                        component: CompanyWorkorderTagsPage,
                        name: 'layout.menu.registry.companies.settings.itemTags',
                      },
                      {
                        key: 'settingsFinancial',
                        permissions: [Authorities.REGISTER_COMPANY_VIEW],
                        component: CompanyFinancialSettingsPage,
                        name: 'layout.menu.registry.companies.settings.financial',
                      },
                      {
                        key: 'integrations',
                        component: CompanyIntegrationsPage,
                        name: 'layout.menu.registry.companies.settings.integrations',
                      },
                      {
                        key: 'companyPurchases',
                        component: CompanyPurchasesPage,
                        name: 'layout.menu.registry.companies.settings.purchase',
                      },
                      {
                        key: 'resource-limitation-periods',
                        component: CompanyResourceLimitationPeriodsPage,
                        name: 'layout.menu.registry.companies.settings.scheduling-config',
                      },
                      {
                        key: 'portoServiceSchedule',
                        component: CompanyPortoScheduleServices,
                        name: 'layout.menu.registry.companies.settings.portoServiceSchedule',
                      },
                      {
                        key: 'boschCoreCredentials',
                        component: CompanyBoschCoreCredentials,
                        name: 'layout.menu.registry.companies.settings.boschCoreCredentials',
                        permission: [
                          Authorities.BOSCH_FEATURES_CONFIG_CORE_CREDENTIALS,
                        ],
                      },
                    ],
                  },
                  {
                    key: 'customTerms',
                    permissions: [Authorities.REGISTER_COMPANY_VIEW],
                    component: CompanyCustomTermsPage,
                    name: 'layout.menu.registry.companies.customTerms',
                    exact: true,
                  },
                  {
                    key: 'invoice',
                    permissions: [
                      Authorities.REGISTER_COMPANY_VIEW,
                      Authorities.CONFIGURATION_USER_INVOICE_SETTINGS_READ,
                    ],
                    component: CompanyInvoicePage,
                    name: 'layout.menu.registry.companies.invoice',
                    exact: true,
                  },
                  {
                    key: 'sintegra',
                    permissions: [Authorities.REGISTER_COMPANY_EDIT],
                    component: CompanySintegraPage,
                    name: 'layout.menu.registry.companies.sintegra',
                    exact: true,
                  },
                  {
                    key: 'coupon',
                    permissions: [Authorities.FISCAL_COUPON_SETTING],
                    component: CompanyCouponPage,
                    name: 'layout.menu.registry.companies.coupon',
                    exact: true,
                  },
                  {
                    key: 'reportConfig',
                    permissions: [Authorities.REGISTER_COMPANY_EDIT],
                    component: CompanyReportPage,
                    name: 'commons.entity.report',
                    exact: true,
                  },
                ],
              },
            ],
          },
          {
            key: 'employees',
            permissions: [Authorities.REGISTER_EMPLOYEE_VIEW],
            exact: true,
            component: EmployeesPage,
            name: 'layout.menu.registry.employee',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'create',
                exact: true,
                component: CreateEmployeePage,
                permissions: [Authorities.REGISTER_EMPLOYEE_ADD],
                name: 'layout.menu.registry.employee.create',
              },
              {
                key: ':employeeId',
                component: EmployeeDetailsPage,
                name: 'layout.menu.registry.employee.details',
                routes: [
                  {
                    key: 'personal',
                    component: EmployeePersonalPage,
                    permissions: [Authorities.REGISTER_EMPLOYEE_VIEW],
                    name: 'layout.menu.registry.employee.personal',
                  },
                  {
                    key: 'professional',
                    component: EmployeeProfessionalPage,
                    permissions: [Authorities.REGISTER_EMPLOYEE_VIEW],
                    name: 'layout.menu.registry.employee.professional',
                  },
                  {
                    key: 'address',
                    component: EmployeeAddressPage,
                    permissions: [Authorities.REGISTER_EMPLOYEE_VIEW],
                    name: 'layout.menu.registry.employee.address',
                  },
                  {
                    key: 'contact',
                    component: EmployeeContactPage,
                    permissions: [Authorities.REGISTER_EMPLOYEE_VIEW],
                    name: 'layout.menu.registry.employee.contact',
                  },
                ],
              },
            ],
          },
          {
            key: 'suppliers',
            permissions: [Authorities.REGISTER_SUPPLIER_VIEW],
            exact: true,
            component: SuppliersPage,
            name: 'layout.menu.registry.suppliers',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'create',
                exact: true,
                component: SuppliersCreatePage,
                permissions: [Authorities.REGISTER_SUPPLIER_ADD],
                name: 'layout.menu.registry.suppliers.create',
              },
              {
                key: ':supplierId',
                component: SupplierDetailsPage,
                permissions: [Authorities.REGISTER_SUPPLIER_VIEW],
                name: 'layout.menu.suplliers.details.generalInfo',
                routes: [
                  {
                    key: 'general',
                    component: SupplierGeneralPage,
                    permissions: [Authorities.REGISTER_SUPPLIER_VIEW],
                    name: 'layout.menu.registry.suppliers.general',
                  },
                  {
                    key: 'address',
                    component: SupplierAddressesPage,
                    permissions: [Authorities.REGISTER_SUPPLIER_VIEW],
                    name: 'layout.menu.registry.suppliers.address',
                  },
                  {
                    key: 'contact',
                    component: SupplierContactsPage,
                    permissions: [Authorities.REGISTER_SUPPLIER_VIEW],
                    name: 'layout.menu.registry.suppliers.contacts',
                  },
                  {
                    key: 'returnedItems',
                    component: SupplierReturnedItemsPage,
                    permissions: [Authorities.REGISTER_SUPPLIER_VIEW],
                    name: 'layout.menu.registry.suppliers.returnedItems',
                  },
                  {
                    key: 'supplierCredit',
                    permissions: [Authorities.REGISTER_SUPPLIER_VIEW],
                    component: SupplierCreditPage,
                    name: 'layout.menu.registry.suppliers.credit',
                  },
                ],
              },
            ],
          },
          {
            key: 'insurers',
            permissions: [Authorities.REGISTER_INSURER_VIEW],
            exact: true,
            component: InsurersPage,
            name: 'layout.menu.registry.insurers',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'create',
                exact: true,
                component: CreateInsurerPage,
                permissions: [Authorities.REGISTER_INSURER_ADD],
                name: 'layout.menu.registry.insurers.create',
              },
              {
                key: ':insurerId',
                component: InsurerDetailsPage,
                permissions: [Authorities.REGISTER_INSURER_VIEW],
                name: 'layout.menu.registry.insurers.details',
                routes: [
                  {
                    key: 'general',
                    permissions: [Authorities.REGISTER_INSURER_VIEW],
                    component: InsurerGeneralPage,
                    name: 'layout.menu.registry.insurers.general',
                  },
                  {
                    key: 'addresses',
                    permissions: [Authorities.REGISTER_INSURER_VIEW],
                    component: InsurerAddressesPage,
                    name: 'layout.menu.registry.insurers.addresses',
                  },
                  {
                    key: 'contacts',
                    permissions: [Authorities.REGISTER_INSURER_VIEW],
                    component: InsurerContactsPage,
                    name: 'layout.menu.registry.insurers.contacts',
                  },
                ],
              },
            ],
          },
          {
            key: 'transport',
            exact: true,
            component: TransportPage,
            name: 'layout.menu.registry.transport',
            menu: {
              icon: <></>,
            },
          },
          {
            key: 'functions',
            exact: true,
            component: FunctionsPage,
            name: 'layout.menu.registry.functions',
            menu: {
              icon: <></>,
            },
          },
        ],
      },
      {
        key: 'movements',
        component: () => null,
        name: 'layout.menu.movements',
        menu: {
          icon: <></>,
        },
        routes: [
          {
            key: 'workOrders',
            exact: true,
            component: WorkOrdersPage,
            name: 'layout.menu.movements.workOrders',
            permissions: [Authorities.MOVIMENTATION_WORKORDER_VIEW],
            menu: { icon: <></> },
            routes: [
              {
                key: 'migration-consult',
                exact: true,
                component: WorkOrderMigrationConsultListPage,
                name: 'layout.menu.movements.workOrders.migration',
                permissions: [],
              },
              {
                key: 'calendar',
                exact: true,
                component: WorkOrderCalendarPage,
                name: 'layout.menu.movements.workOrders.calendar',
                permissions: [Authorities.MOVIMENTATION_WORKORDER_FOLLOW_UP],
              },
              {
                key: 'indicators',
                exact: true,
                component: WorkOrderIndicatorsPage,
                name: 'layout.menu.movements.workOrders.indicators',
                permissions: [
                  Authorities.MOVIMENTATION_WORKORDER_VIEW_INDICATORS_PAGE,
                ],
              },
              {
                key: 'import',
                component: WorkOrderImportPage,
                permissions: [Authorities.MOVIMENTATION_WORKORDER_IMPORT],
                exact: true,
                name: 'layout.menu.movements.workOrders.details.import',
              },
              {
                key: ':workOrderId',
                component: WorkOrderDetailsPage,
                permissions: [
                  Authorities.MOVIMENTATION_WORKORDER_VIEW,
                  Authorities.MOVIMENTATION_WORKORDER_EDIT,
                ],
                exact: true,
                name: 'layout.menu.movements.workOrders.details',
                routes: [
                  {
                    key: 'complements/:complementId/generalInfo',
                    component: WorkOrderGeneralInfoPage,
                    name: 'layout.menu.movements.workOrders.details.generalInfo',
                    permissions: [
                      Authorities.MOVIMENTATION_WORKORDER_VIEW,
                      Authorities.MOVIMENTATION_WORKORDER_EDIT,
                    ],
                  },
                  {
                    key: 'complements/:complementId/partsAndTasks',
                    component: WorkOrderPartsAndTasksPage,
                    name: 'layout.menu.movements.workOrders.details.partsAndTasks',
                    permissions: [
                      Authorities.MOVIMENTATION_WORKORDER_VIEW,
                      Authorities.MOVIMENTATION_WORKORDER_ITEM_VIEW_INFORMATION,
                      Authorities.MOVIMENTATION_WORKORDER_EDIT,
                    ],
                  },
                  {
                    key: 'complements/:complementId/observations',
                    component: WorkOrderObservationsPage,
                    name: 'layout.menu.movements.workOrders.details.observations',
                    permissions: [
                      Authorities.MOVIMENTATION_WORKORDER_VIEW,
                      Authorities.MOVIMENTATION_WORKORDER_EDIT,
                    ],
                  },
                  {
                    key: 'complements/:complementId/commissions',
                    component: CommissionsPage,
                    name: 'layout.menu.movements.workOrders.details.commissions',
                    permissions: [
                      Authorities.MOVIMENTATION_WORKORDER_VIEW,
                      Authorities.MOVIMENTATION_WORKORDER_VIEW_COMMISSIONS_PAYMENT,
                      Authorities.MOVIMENTATION_WORKORDER_EDIT,
                    ],
                  },
                  {
                    key: 'complements/:complementId/financial',
                    component: WorkOrderFinancialPage,
                    name: 'layout.menu.movements.workOrders.details.financial',
                    permissions: [
                      Authorities.MOVIMENTATION_WORKORDER_VIEW,
                      Authorities.MOVIMENTATION_WORKORDER_EDIT,
                    ],
                  },
                  {
                    key: 'complements/:complementId/invoice',
                    component: WorkOrderInvoicePage,
                    name: 'layout.menu.movements.workOrders.details.invoice',
                    permissions: [
                      Authorities.MOVIMENTATION_WORKORDER_VIEW,
                      Authorities.MOVIMENTATION_WORKORDER_EDIT,
                    ],
                  },
                  {
                    key: 'complements/:complementId/emails',
                    component: WorkOrderMailPage,
                    name: 'layout.menu.movements.workOrders.details.emails',
                    permissions: [
                      Authorities.MOVIMENTATION_WORKORDER_VIEW,
                      Authorities.MOVIMENTATION_WORKORDER_EDIT,
                    ],
                  },
                ],
              },
            ],
          },
          {
            key: 'workorderChecklist',
            component: WorkorderChecklistPage,
            exact: true,
            name: 'layout.menu.movements.workOrders.details.checklist',
            routes: [
              {
                key: ':checklistItemId',
                component: WorkorderChecklistPage,
                exact: true,
                name: 'layout.menu.movements.workOrders.details.checklist.detail',
                routes: [
                  {
                    key: 'damages',
                    component: WorkorderChecklistDamagePage,
                    name: 'layout.menu.movements.workOrders.details.checklist.damages',
                  },
                  {
                    key: 'images',
                    component: WorkorderChecklistImagesPage,
                    name: 'layout.menu.movements.workOrders.details.checklist.images',
                  },
                  {
                    key: 'observations',
                    component: ChecklistObservationsPage,
                    name: 'layout.menu.movements.workOrders.details.checklist.observations',
                  },
                  {
                    key: 'accessories',
                    component: WorkorderChecklistAccessoriesPage,
                    name: 'layout.menu.movements.workOrders.details.checklist.accessories',
                  },
                  {
                    key: 'requestedServices',
                    component: WorkorderChecklistRequestedServicesPage,
                    name: 'layout.menu.movements.workOrders.details.checklist.requestedServices',
                  },
                  {
                    key: 'quickChecklist',
                    component: WorkorderChecklistQuickChecklistPage,
                    name: 'layout.menu.movements.workOrders.details.checklist.quickChecklist',
                  },
                  {
                    key: 'complementItems',
                    component: WorkorderChecklistComplementItemsPage,
                    name: 'layout.menu.movements.workOrders.details.checklist.complementItems',
                  },
                  {
                    key: 'futureServices',
                    component: WorkorderChecklistFutureServicesPage,
                    name: 'layout.menu.movements.workOrders.details.checklist.futureServices',
                  },
                ],
              },
            ],
          },
          {
            key: 'directSale',
            permissions: [Authorities.MOVIMENTATION_SALE_VIEW],
            exact: true,
            component: DirectSalePage,
            name: 'layout.menu.movements.directSale',
            menu: { icon: <></> },
            routes: [
              {
                key: 'indicators',
                permissions: [Authorities.MOVIMENTATION_SALE_VIEW],
                component: DirectSaleIndicatorsPage,
                name: 'layout.menu.movements.directSale.indicators',
                exact: true,
              },
              {
                key: 'create',
                permissions: [Authorities.MOVIMENTATION_SALE_ADD],
                component: DirectSaleCreatePage,
                name: 'layout.menu.movements.directSale.create',
                exact: true,
              },
              {
                key: ':directSaleId',
                component: DirectSaleDetailsPage,
                name: 'layout.menu.movements.directSale.details',
                routes: [
                  {
                    key: 'general',
                    permissions: [
                      Authorities.MOVIMENTATION_SALE_EDIT,
                      Authorities.MOVIMENTATION_SALE_VIEW,
                    ],
                    component: DirectSaleGeneralInfoPage,
                    name: 'layout.menu.movements.directSale.details.general',
                  },
                  {
                    key: 'financialDirectSale',
                    component: FinancialDirectSalePage,
                    name: 'layout.menu.movement.directSale.financial',
                    permissions: [
                      Authorities.MOVIMENTATION_SALE_EDIT,
                      Authorities.MOVIMENTATION_SALE_VIEW,
                      Authorities.MOVIMENTATION_SALE_NEGOTIATE_FINANCIAL,
                    ],
                  },
                ],
              },
            ],
          },
          {
            key: 'inventory',
            permissions: [Authorities.MOVIMENTATION_INVENTORY_VIEW],
            exact: true,
            component: InventoriesPage,
            name: 'layout.menu.movements.inventory',
            menu: { icon: <></> },
            routes: [
              {
                key: ':inventoryId',
                permissions: [Authorities.FISCAL_INVOICE_VIEW],
                component: InventoryDetailsPage,
                name: 'layout.menu.movements.inventory.details',
              },
            ],
          },
          {
            key: 'purchases',
            permissions: [Authorities.MOVIMENTATION_PURCHASE_VIEW],
            exact: true,
            component: PurchasesPage,
            name: 'layout.menu.movements.purchases',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'purchasesReleases',
                permissions: [Authorities.MOVIMENTATION_PURCHASE_VIEW],
                component: PurchasesReleasesPage,
                name: 'layout.menu.movements.purchases.releases',
                exact: true,
                routes: [
                  {
                    key: 'purchasesCreate',
                    permissions: [Authorities.MOVIMENTATION_PURCHASE_ADD],
                    component: PurchasesReleasesCreatePage,
                    name: 'layout.menu.movements.purchases.create',
                    exact: true,
                  },
                  {
                    key: ':purchaseId',
                    component: PurchaseDetailsPage,
                    name: 'layout.menu.movements.purchases.details',
                    routes: [
                      {
                        key: 'general',
                        permissions: [Authorities.MOVIMENTATION_PURCHASE_VIEW],
                        component: PurchaseGeneralInfoPage,
                        name: 'layout.menu.movements.purchases.details.general',
                      },
                      {
                        key: 'itemsPurchase',
                        permissions: [
                          Authorities.MOVIMENTATION_PURCHASE_VIEW,
                          Authorities.MOVIMENTATION_PURCHASE_ITEM_READ,
                        ],
                        component: PurchaseItemsPurchasePage,
                        name: 'layout.menu.movements.purchases.details.itemsPurchase',
                        exact: true,
                        routes: [
                          {
                            key: 'createItemPurchase/part/:partId',
                            permissions: [
                              Authorities.MOVIMENTATION_PURCHASE_VIEW,
                              Authorities.MOVIMENTATION_PURCHASE_ITEM_READ,
                            ],
                            component: PurchaseCreateItemPurchase,
                            name: 'layout.menu.movements.purchases.details.itemsPurchase.create',
                            exact: true,
                          },
                          {
                            key: 'createItemPurchase/consumable/:consumableId',
                            permissions: [
                              Authorities.MOVIMENTATION_PURCHASE_VIEW,
                              Authorities.MOVIMENTATION_PURCHASE_ITEM_READ,
                            ],
                            component: PurchaseCreateItemPurchase,
                            name: 'layout.menu.movements.purchases.details.itemsPurchase.create',
                            exact: true,
                          },
                          {
                            key: 'createItemPurchase/task',
                            permissions: [
                              Authorities.MOVIMENTATION_PURCHASE_VIEW,
                              Authorities.MOVIMENTATION_PURCHASE_ITEM_READ,
                            ],
                            component: PurchaseCreateItemPurchase,
                            name: 'layout.menu.movements.purchases.details.itemsPurchase.create',
                            exact: true,
                          },
                          {
                            key: 'detailItemPurchase/item/:itemId/detail',
                            permissions: [
                              Authorities.MOVIMENTATION_PURCHASE_VIEW,
                              Authorities.MOVIMENTATION_PURCHASE_ITEM_READ,
                            ],
                            component: PurchaseDetailItemPurchase,
                            name: 'layout.menu.movements.purchases.details.itemsPurchase.details',
                            exact: true,
                          },
                        ],
                      },
                      {
                        key: 'dataFreigth',
                        permissions: [Authorities.MOVIMENTATION_PURCHASE_VIEW],
                        component: PurchaseDataFreightPage,
                        name: 'layout.menu.movements.purchases.details.data.freight',
                      },
                      {
                        key: 'taxes',
                        permissions: [Authorities.MOVIMENTATION_PURCHASE_VIEW],
                        component: PurchaseTaxesPage,
                        name: 'layout.menu.movements.purchases.details.taxes',
                      },
                      {
                        key: 'purchaseGroupings',
                        permissions: [Authorities.MOVIMENTATION_PURCHASE_VIEW],
                        component: PurchaseGroupingsPage,
                        exact: true,
                        name: 'layout.menu.movements.purchases.details.groupings',
                      },
                      {
                        key: 'purchaseFinancial',
                        permissions: [Authorities.MOVIMENTATION_PURCHASE_VIEW],
                        component: PurchaseFinancialPage,
                        exact: true,
                        name: 'layout.menu.movements.purchases.details.financial',
                      },
                    ],
                  },
                ],
              },
              {
                key: 'purchaseReturn',
                component: PurchaseReturnPage,
                name: 'layout.menu.movements.purchaseReturn',
                permissions: [Authorities.MOVIMENTATION_PURCHASE_RETURN],
              },
              {
                key: 'purchasingGrouping',
                component: PurchasingGroupingPage,
                name: 'layout.menu.movements.purchases.purchasingGrouping',
                permissions: [
                  Authorities.MOVIMENTATION_PURCHASE_VIEW_PURCHASE_GROUPS,
                  Authorities.MOVIMENTATION_PURCHASE_SHOPPING_GROUPING,
                ],
              },
              {
                key: 'importPurchase',
                component: PurchaseImportPage,
                name: 'layout.menu.movements.purchases.purchasingImport',
                exact: true,
                permissions: [Authorities.MOVIMENTATION_PURCHASE_IMPORT_XML],
                routes: [
                  {
                    key: 'confirmImportPurchase',
                    component: ConfirmImportPurchasePage,
                    name: 'layout.menu.movements.purchases.purchasingConfirmImport',
                    exact: true,
                  },
                ],
              },
              {
                key: 'partsLink24',
                component: PurchasingPartsLinkPage,
                name: 'layout.menu.movements.purchases.partsLink24',
                exact: true,
                permissions: [Authorities.MOVIMENTATION_PURCHASE_PARTSLINK24],
                routes: [
                  {
                    key: 'confirmImportPurchaseCsv',
                    component: ConfirmImportPurchaseCsvPage,
                    permissions: [
                      Authorities.MOVIMENTATION_PURCHASE_PARTSLINK24,
                    ],
                    name: 'layout.menu.movements.deliveryOrReturnOfMaterials.deliverMaterial',
                    exact: true,
                  },
                ],
              },
            ],
          },
          {
            key: 'deliveryOfMaterials',
            exact: true,
            component: DeliveryOfMaterialsPage,
            permissions: [Authorities.MOVIMENTATION_MATERIAL_VIEW],
            name: 'layout.menu.movements.deliveryOrReturnOfMaterials',
            menu: { icon: <></> },
            routes: [
              {
                key: 'deliverMaterial',
                component: DeliverMaterialCreatePage,
                name: 'layout.menu.movements.deliveryOrReturnOfMaterials.deliverMaterial',
                permissions: [
                  Authorities.MOVIMENTATION_MATERIAL_DELIVER_MATERIAL,
                ],
              },
              {
                key: 'returnMaterial',
                component: ReturnMaterialCreatePage,
                name: 'layout.menu.movements.deliveryOrReturnOfMaterials.returnMaterial',
                permissions: [
                  Authorities.MOVIMENTATION_MATERIAL_RETURN_MATERIAL,
                ],
              },
              {
                key: ':returnMaterialId/delivery',
                component: DeliveryDetailsPage,
                name: 'layout.menu.movements.deliveryOrReturnOfMaterials.delivery',
                permissions: [Authorities.MOVIMENTATION_MATERIAL_VIEW],
              },
              {
                key: ':returnMaterialId/return',
                component: ReturnDetailsPage,
                name: 'layout.menu.movements.deliveryOrReturnOfMaterials.return',
                permissions: [Authorities.MOVIMENTATION_MATERIAL_VIEW],
              },
            ],
          },
          {
            key: 'diagnostics',
            exact: true,
            component: DiagnosticsPage,
            name: 'layout.menu.movements.diagnostics',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'create',
                component: CreateDiagnosticPage,
                name: 'layout.menu.movements.diagnostics.create',
              },
              {
                key: ':diagnosticId',
                component: DiagnosticDetailsPage,
                name: 'layout.menu.movements.diagnostics.details',
              },
            ],
          },
          {
            key: 'quotations',
            exact: true,
            component: QuotationsPage,
            permissions: [Authorities.MOVIMENTATION_QUOTATION_VIEW],
            name: 'layout.menu.movements.quotations',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: ':quotationId',
                component: QuotationDetailsPage,
                permissions: [Authorities.MOVIMENTATION_QUOTATION_VIEW],
                name: 'layout.menu.movements.quotations.details',
                routes: [
                  {
                    key: 'items',
                    component: QuotationDetailsItemsPage,
                    permissions: [Authorities.MOVIMENTATION_QUOTATION_VIEW],
                    name: 'layout.menu.movements.quotations.details.items',
                  },
                  {
                    key: 'suppliers',
                    component: QuotationDetailsSuppliersPage,
                    permissions: [Authorities.MOVIMENTATION_QUOTATION_VIEW],
                    name: 'layout.menu.movements.quotations.details.suppliers',
                  },
                  {
                    key: 'offersConfiguration',
                    component: QuotationDetailsOffersConfigurationPage,
                    permissions: [Authorities.MOVIMENTATION_QUOTATION_VIEW],
                    name: 'layout.menu.movements.quotations.details.offersConfiguration',
                  },
                  {
                    key: 'requestQuotation',
                    component: QuotationDetailsRequestQuotationPage,
                    permissions: [
                      Authorities.MOVIMENTATION_QUOTATION_VIEW,
                      Authorities.MOVIMENTATION_QUOTATION_REQUEST_PURCHASE,
                    ],
                    name: 'layout.menu.movements.quotations.details.requestQuotation',
                  },
                ],
              },
            ],
          },
          {
            key: 'stockCorrections',
            exact: true,
            component: StockCorrectionsPage,
            name: 'layout.menu.movements.stockCorrections',
            permissions: [Authorities.MOVIMENTATION_STOCKCORRECTION],
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'create',
                component: CreateStockCorrectionPage,
                permissions: [Authorities.MOVIMENTATION_STOCKCORRECTION],
                name: 'layout.menu.movements.stockCorrections.create',
              },
              {
                key: ':stockCorrectionId',
                component: StockCorrectionDetailsPage,
                permissions: [Authorities.MOVIMENTATION_STOCKCORRECTION],
                name: 'layout.menu.movements.stockCorrections.details',
              },
            ],
          },
          {
            key: 'stock-transfer',
            exact: true,
            component: StockTransferPage,
            permissions: [Authorities.MOVIMENTATION_STOCKTRANSFER],
            name: 'layout.menu.movements.stockTransfer',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'create',
                component: StockTransferCreatePage,
                permissions: [Authorities.MOVIMENTATION_STOCKTRANSFER],
                name: 'layout.menu.movements.stockTransfer.create',
              },
              {
                key: ':stockTransferId',
                component: StockTransferDetailsPage,
                permissions: [Authorities.MOVIMENTATION_STOCKCORRECTION],
                name: 'layout.menu.movements.stockTransfer.details',
              },
            ],
          },
          {
            key: 'employeeCommissions',
            exact: true,
            component: EmployeeCommissionsPage,
            permissions: [Authorities.VIEW_EMPLOYEE_COMMISSION],
            name: 'layout.menu.movements.employeeCommissions',
            menu: {
              icon: <></>,
            },
          },
        ],
      },
      {
        key: 'financial',
        component: () => null,
        name: 'layout.menu.financial',
        menu: {
          icon: <></>,
        },
        routes: [
          {
            key: 'accounts',
            component: AccountsPage,
            name: 'layout.menu.financial.accounts',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'bankAccounts',
                permissions: [Authorities.REGISTER_BANK_ACCOUNT_VIEW],
                exact: true,
                component: BankAccountsPage,
                name: 'layout.menu.registry.bankAccounts',
                routes: [
                  {
                    key: 'create',
                    permissions: [Authorities.REGISTER_BANK_ACCOUNT_ADD],
                    exact: true,
                    component: BankAccountsCreatePage,
                    name: 'layout.menu.registry.bankAccounts.create',
                  },
                  {
                    key: ':bankAccountId',
                    name: 'layout.menu.registry.bankAccounts.details',
                    component: BankAccountsDetailsPage,
                    routes: [
                      {
                        key: 'general',
                        permissions: [Authorities.REGISTER_BANK_ACCOUNT_VIEW],
                        component: BankAccountsGeneralPage,
                        name: 'layout.menu.registry.bankAccounts.details',
                      },
                      {
                        key: 'contact',
                        permissions: [Authorities.REGISTER_BANK_ACCOUNT_VIEW],
                        component: BankAccountsContactPage,
                        name: 'layout.menu.registry.employee.contact',
                      },
                      {
                        key: 'configurationBankSlip',
                        permissions: [Authorities.REGISTER_BANK_ACCOUNT_VIEW],
                        component: BankAccountConfigBankSlipPage,
                        name: 'layout.menu.registry.bankAccounts.configBankSlip',
                      },
                    ],
                  },
                ],
              },
              {
                key: 'planAccounts',
                permissions: [Authorities.REGISTER_PLAN_ACCOUNT_VIEW],
                component: PlanAccountsPage,
                name: 'layout.menu.financial.accounts.planAccounts',
              },
              {
                key: 'documentTypes',
                permissions: [Authorities.REGISTER_DOCUMENT_TYPE_VIEW],
                exact: true,
                component: DocumentTypesPage,
                name: 'layout.menu.financial.accounts.documentTypes',
                routes: [
                  {
                    key: ':documentTypeId',
                    permissions: [Authorities.REGISTER_DOCUMENT_TYPE_VIEW],
                    component: DocumentTypesDetailsPage,
                    name: 'layout.menu.financial.accounts.documentTypes.details',
                  },
                ],
              },
              {
                key: 'paymentConditions',
                permissions: [Authorities.REGISTER_PAYMENT_CONDITIONS_VIEW],
                component: PaymentConditionsPage,
                name: 'layout.menu.financial.accounts.paymentConditions',
              },
              {
                key: 'costCenters',
                permissions: [Authorities.REGISTER_COST_CENTER_VIEW],
                component: CostCentersPage,
                name: 'layout.menu.financial.accounts.costCenters',
              },
            ],
          },
          {
            key: 'billToPay',
            component: BillToPayPage,
            name: 'layout.menu.financial.billToPay',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'releaseBillToPay',
                exact: true,
                component: ReleaseBillToPayPage,
                name: 'layout.menu.financial.billToPay.releases',
                permissions: [
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_VIEW,
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_LAUNCH,
                ],
                routes: [
                  {
                    key: 'create',
                    exact: true,
                    component: ReleasesCreatePage,
                    permissions: [
                      Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_ADD,
                      Authorities.FINANCIAL_ACCOUNT_PAYABLE_GENERATE_ACCOUNTS_PAYABLE,
                    ],
                    name: 'layout.menu.registry.billToPay.release.create',
                  },
                  // {
                  //   key: 'detail/accountPayableId/:accountPayableId/installmentPayableId/:installmentPayableId',
                  //   component: ReleasesDetailsPage,
                  //   exact: true,
                  //   name: 'layout.menu.registry.billToPay.release.detail',
                  //   permissions: [
                  //     Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_VIEW,
                  //     Authorities.FINANCIAL_ACCOUNT_PAYABLE_EDIT,
                  //   ],
                  // },
                  {
                    key: 'detail/accountPayableId/:accountPayableId/installmentPayableId/:installmentPayableId',
                    component: () => (
                      <Redirect to={`${window.location.pathname}/general`} />
                    ),
                    exact: true,
                    name: 'layout.menu.registry.billToPay.release.detail',
                    permissions: [
                      Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_VIEW,
                      Authorities.FINANCIAL_ACCOUNT_PAYABLE_EDIT,
                    ],
                    routes: [
                      {
                        key: 'general',
                        component: ReleasesDetailsPage,
                        exact: true,
                        name: 'layout.menu.registry.billToPay.release.detail',
                        permissions: [
                          Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_VIEW,
                          Authorities.FINANCIAL_ACCOUNT_PAYABLE_EDIT,
                        ],
                      },
                      {
                        key: 'attachments',
                        component: BillToPayReleasesAttachmentPage,
                        exact: true,
                        name: 'layout.menu.registry.billToPay.release.attachments',
                        permissions: [
                          Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_VIEW,
                          Authorities.FINANCIAL_ACCOUNT_PAYABLE_EDIT,
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                key: 'releases-migration-consult',
                exact: true,
                component: ReleasesBillToPayMigrationConsultPage,
                name: 'layout.menu.financial.billToPay.releases.migration.consult',
              },
              {
                key: 'calendarAccountPayable',
                exact: true,
                component: ViewCalendarAccountPayablePage,
                name: 'layout.menu.financial.billToPay.calendar',
                permissions: [
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_VIEW,
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_LAUNCH,
                ],
              },
              {
                key: 'forecastPayable',
                exact: true,
                component: ForecastPayablePage,
                permissions: [
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_INSTALLMENTS_VIEW,
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_VIEW_FORECAST_OF_ACCOUNTS_PAYABLE,
                ],
                name: 'layout.menu.financial.billToPay.predictions',
                routes: [
                  {
                    key: 'create',
                    exact: true,
                    component: ForecastPayableCreatePage,
                    name: 'layout.menu.registry.billToPay.predictions.create',
                    permissions: [
                      Authorities.FINANCIAL_ACCOUNT_PAYABLE_ADD_FORECAST_OF_ACCOUNTS_PAYABLE,
                    ],
                  },
                  {
                    key: ':forecastPayableId',
                    exact: true,
                    component: ForecastPayableDetailsPage,
                    name: 'layout.menu.registry.billToPay.predictions.details',
                    permissions: [
                      Authorities.FINANCIAL_ACCOUNT_PAYABLE_EDIT_FORECAST_OF_ACCOUNTS_PAYABLE,
                    ],
                  },
                ],
              },
              {
                key: 'grouping',
                permissions: [
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_GROUP_OF_ACCOUNTS_PAYABLE,
                  Authorities.FINANCIAL_ACCOUNT_PAYABLE_GROUP_ACCOUNTS_PAYABLE,
                ],
                exact: true,
                component: GroupingsBillToPayPage,
                name: 'layout.menu.financial.billToPay.grouping',
                routes: [
                  {
                    key: 'create',
                    exact: true,
                    component: BankAccountsCreatePage,
                    name: 'layout.menu.registry.billToPay.create',
                  },
                ],
              },
            ],
          },
          {
            key: 'billToReceiver',
            component: BillToReceivePage,
            name: 'layout.menu.financial.billToReceive',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'releaseBillToReceiver',
                exact: true,
                component: ReleaseBillToReceivePage,
                name: 'layout.menu.financial.billToReceive.releases',
                permissions: [
                  Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_VIEW,
                  Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_LAUCH,
                ],
                routes: [
                  {
                    key: 'create',
                    exact: true,
                    component: ReleasesBillToReceiveCreatePage,
                    name: 'layout.menu.registry.billToRelease.release.create',
                    permissions: [Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_ADD],
                  },
                  {
                    key: ':releaseId/installment/:installmentId',
                    exact: true,
                    component: () => (
                      <Redirect to={`${window.location.pathname}/general`} />
                    ),
                    name: 'layout.menu.registry.billToRelease.release.detail',
                    permissions: [
                      Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_EDIT,
                    ],
                    routes: [
                      {
                        key: 'general',
                        exact: true,
                        component: ReleasesBillToReceiveDetailPage,
                        name: 'layout.menu.registry.billToRelease.release.detail',
                        permissions: [
                          Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_EDIT,
                        ],
                      },
                      {
                        key: 'attachments',
                        component: BillToReceiveReleasesAttachmentPage,
                        exact: true,
                        name: 'layout.menu.registry.billToRelease.release.attachments',
                        permissions: [
                          Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_EDIT,
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                key: 'releases-migration-consult',
                exact: true,
                component: ReleasesBillToReceiveMigrationConsultPage,
                name: 'layout.menu.financial.billToReceive.releases.migration.consult',
              },
              {
                key: 'calendarAccountReceivable',
                exact: true,
                component: ViewCalendarAccountReceivablePage,
                permissions: [Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_VIEW],
                name: 'layout.menu.financial.billToPay.calendar',
              },
              {
                key: 'grouping',
                exact: true,
                permissions: [
                  Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_GROUPING,
                  Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_GROUP,
                ],
                component: GroupingsBillToReceivePage,
                name: 'layout.menu.financial.billToReceive.grouping',
              },
            ],
          },
          {
            key: 'bankingEntry',
            component: BankingEntryPage,
            name: 'layout.menu.financial.bankEntry',
            permissions: [Authorities.FINANCIAL_BANKING_ENTRIES_VIEW],
            exact: true,
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'create',
                permissions: [Authorities.FINANCIAL_BANKING_ENTRIES_ADD],
                exact: true,
                component: BankingEntryCreatePage,
                name: 'layout.menu.registry.bankEntry.release.create',
              },
              {
                key: ':bankingEntryId',
                exact: true,
                component: BankingEntryDetailsPage,
                permissions: [
                  Authorities.FINANCIAL_BANKING_ENTRIES_VIEW,
                  Authorities.FINANCIAL_BANKING_ENTRIES_EDIT,
                ],
                name: 'layout.menu.registry.bankEntry.release.detail',
              },
            ],
          },
          {
            key: 'cashMovement',
            component: CashMovementPage,
            name: 'layout.menu.financial.cashMovement',
            permissions: [
              Authorities.BANKING_ENTRIES_CASH_MOVEMENT_VIEW,
              Authorities.BANKING_ENTRIES_CASH_MOVEMENT,
            ],
            menu: {
              icon: <></>,
            },
            exact: true,
          },
          {
            key: 'bankSlip',
            name: 'layout.menu.financial.bankSlip',
            component: BankSlipPage,
            permissions: [
              Authorities.FINANCIAL_BILL_TICKET_BANK_SLIP,
              Authorities.FINANCIAL_BILL_VIEW_TICKET_HISTORY,
            ],
            menu: {
              icon: <></>,
            },
          },
          {
            key: 'bankConciliation',
            name: 'layout.menu.financial.bankConciliation',
            component: BankConciliationPage,
            permissions: [Authorities.BANK_CONCILIATION],
            menu: {
              icon: <></>,
            },
          },
        ],
      },
      {
        key: 'fiscal',
        name: 'layout.menu.fiscal',
        component: () => null,
        menu: {
          icon: <></>,
        },
        routes: [
          {
            key: 'sped',
            permissions: [
              Authorities.SPED_DOCUMENT_VIEW,
              Authorities.SPED_CONFIG_VIEW,
            ],
            exact: true,
            component: SpedPage,
            name: 'layout.menu.fiscal.invoice.sped',
            menu: { icon: <></> },
            routes: [
              {
                key: 'documents',
                permissions: [Authorities.SPED_DOCUMENT_VIEW],
                exact: true,
                component: SpedDocumentsPage,
                name: 'layout.menu.fiscal.invoice.spedDocuments',
                routes: [
                  {
                    key: ':id',
                    permissions: [Authorities.SPED_DOCUMENT_VIEW],
                    exact: true,
                    component: SpedDocumentDetailPage,
                    name: 'layout.menu.fiscal.invoice.spedDocuments.detail',
                    routes: [],
                  },
                ],
              },
              {
                key: 'config',
                permissions: [Authorities.SPED_CONFIG_VIEW],
                exact: true,
                component: SpedConfigPage,
                name: 'layout.menu.fiscal.invoice.spedConfig',
                routes: [],
              },
            ],
          },
          {
            key: 'sintegra',
            permissions: [Authorities.FISCAL_INVOICE_GENERATE_SINTEGRA],
            exact: true,
            component: SintegraPage,
            name: 'layout.menu.fiscal.invoice.sintegra',
            menu: {
              icon: <></>,
            },
            routes: [],
          },
          {
            key: 'ncm',
            permissions: [Authorities.REGISTER_NCM_VIEW],
            exact: true,
            component: NcmsPage,
            name: 'layout.menu.fiscal.ncm',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'create',
                permissions: [Authorities.REGISTER_NCM_VIEW],
                component: CreateNcmPage,
                name: 'layout.menu.fiscal.ncm.create',
              },
              {
                key: ':ncmId',
                permissions: [
                  Authorities.REGISTER_NCM_VIEW,
                  Authorities.FISCAL_INVOICE_CHANGE_NCM,
                ],
                component: NcmDetailsPage,
                name: 'layout.menu.fiscal.ncm.details',
              },
            ],
          },
          {
            key: 'coupon',
            permissions: [Authorities.FISCAL_COUPON_VIEW_LIST],
            exact: true,
            component: CouponsPage,
            name: 'layout.menu.fiscal.coupon',
            menu: {
              icon: <></>,
            },
          },
          {
            key: 'invoice',
            permissions: [Authorities.FISCAL_INVOICE_VIEW],
            exact: true,
            component: InvoicePage,
            name: 'layout.menu.fiscal.invoice',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: `${InvoiceType.CFE}/:invoiceId`,
                permissions: [Authorities.FISCAL_INVOICE_VIEW],
                component: () => (
                  <PageRedirect path="/app/fiscal/invoice/general" />
                ),
                name: 'layout.menu.fiscal.invoice.cfe.general',
                exact: true,
                routes: [
                  {
                    component: InvoiceCFeGeneralDataPage,
                    key: 'general',
                    permissions: [
                      Authorities.FISCAL_INVOICE_VIEW,
                      Authorities.FISCAL_INVOICE_EDIT,
                    ],
                    name: 'layout.menu.fiscal.invoice.cfe.general',
                    exact: true,
                  },
                  {
                    component: InvoiceCFeRecipientPage,
                    key: 'destination',
                    permissions: [
                      Authorities.FISCAL_INVOICE_VIEW,
                      Authorities.FISCAL_INVOICE_EDIT,
                    ],
                    name: 'layout.menu.fiscal.invoice.cfe.recipient',
                    exact: true,
                  },
                  {
                    component: InvoiceCFeItensPage,
                    key: 'items',
                    permissions: [
                      Authorities.FISCAL_INVOICE_VIEW,
                      Authorities.FISCAL_INVOICE_EDIT,
                    ],
                    name: 'layout.menu.fiscal.invoice.cfe.items',
                    exact: true,
                  },
                  {
                    component: InvoiceCFePaymentsMethodPage,
                    key: 'payments',
                    permissions: [
                      Authorities.FISCAL_INVOICE_VIEW,
                      Authorities.FISCAL_INVOICE_EDIT,
                    ],
                    name: 'layout.menu.fiscal.invoice.cfe.payments',
                    exact: true,
                  },
                ],
              },
              {
                key: InvoiceType.NFE,
                permissions: [Authorities.FISCAL_INVOICE_VIEW],
                component: InvoiceNFPage,
                name: 'layout.menu.fiscal.invoice.createNFe',
                exact: true,
                routes: [
                  {
                    key: ':invoiceId',
                    permissions: [Authorities.FISCAL_INVOICE_VIEW],
                    component: InvoiceNFeDetailsPage,
                    name: 'layout.menu.fiscal.invoice.detailsNFe',
                    exact: true,
                    routes: [
                      {
                        key: 'datas',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceEditGeneralPage,
                        name: 'layout.menu.fiscal.invoice.createNFe.datasNFe',
                        exact: true,
                      },
                      {
                        key: 'recipient',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceRecipientPage,
                        name: 'layout.menu.fiscal.invoice.create.recipient',
                        exact: true,
                      },
                      {
                        key: 'noteItens',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceNoteItensPage,
                        name: 'layout.menu.movement.fiscalReport.invoiceNoteItems',
                        exact: true,
                        routes: [
                          {
                            key: 'createItemInvoice/part/:invoicePartId',
                            permissions: [Authorities.FISCAL_INVOICE_VIEW],
                            component: InvoiceNoteItemsSelectPartForm,
                            name: 'purchases.details.itemsPurchase.selectPart',
                            exact: true,
                          },
                          {
                            key: 'editeItemInvoice/part/:invoicePartId',
                            permissions: [Authorities.FISCAL_INVOICE_VIEW],
                            component: InvoiceEditNoteItemsSelectPartForm,
                            name: 'purchases.details.itemsPurchase.selectPart',
                            exact: true,
                          },
                        ],
                      },
                      {
                        key: 'transport',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_VIEW_CARRIER,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceTransportPage,
                        name: 'layout.menu.tax.receipt.transport',
                        exact: true,
                      },
                      {
                        key: 'paymentConditions',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoicePaymentConditionGeneralPage,
                        name: 'layout.menu.financial.accounts.paymentConditions',
                        exact: true,
                      },
                      {
                        key: 'additionalData',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceAdditionalDataPage,
                        name: 'layout.menu.fiscal.invoice.createNFe.additionalData',
                        exact: true,
                      },
                      {
                        key: 'acc-e',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceCcePage,
                        name: 'layout.menu.fiscal.invoice.createNFe.cce',
                        exact: true,
                      },
                    ],
                  },
                ],
              },
              {
                key: InvoiceType.NFC,
                permissions: [Authorities.FISCAL_INVOICE_VIEW],
                component: InvoiceNFPage,
                name: 'layout.menu.fiscal.invoice.createNFCe',
                exact: true,
                routes: [
                  {
                    key: ':invoiceId',
                    permissions: [
                      Authorities.FISCAL_INVOICE_VIEW,
                      Authorities.FISCAL_INVOICE_EDIT,
                    ],
                    component: InvoiceNFCeDetailsPage,
                    name: 'layout.menu.fiscal.invoice.detailsNFCe',
                    routes: [
                      {
                        key: 'datas',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceEditGeneralPage,
                        name: 'layout.menu.fiscal.invoice.createNFCe.datasNFCe',
                        exact: true,
                      },
                      {
                        key: 'recipient',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceRecipientPage,
                        name: 'layout.menu.fiscal.invoice.create.recipient',
                        exact: true,
                      },
                      {
                        key: 'noteItens',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceNoteItensPage,
                        name: 'layout.menu.movement.fiscalReport.invoiceNoteItems',
                        exact: true,
                        routes: [
                          {
                            key: 'createItemInvoice/part/:invoicePartId',
                            permissions: [Authorities.FISCAL_INVOICE_VIEW],
                            component: InvoiceNoteItemsSelectPartForm,
                            name: 'purchases.details.itemsPurchase.selectPart',
                            exact: true,
                          },
                          {
                            key: 'editeItemInvoice/part/:invoicePartId',
                            permissions: [Authorities.FISCAL_INVOICE_VIEW],
                            component: InvoiceEditNoteItemsSelectPartForm,
                            name: 'purchases.details.itemsPurchase.selectPart',
                            exact: true,
                          },
                        ],
                      },
                      {
                        key: 'transport',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_VIEW_CARRIER,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceTransportPage,
                        name: 'layout.menu.tax.receipt.transport',
                        exact: true,
                      },
                      {
                        key: 'paymentConditions',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoicePaymentConditionGeneralPage,
                        name: 'layout.menu.financial.accounts.paymentConditions',
                        exact: true,
                      },
                      {
                        key: 'additionalData',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceAdditionalDataPage,
                        name: 'layout.menu.fiscal.invoice.createNFe.additionalData',
                        exact: true,
                      },
                    ],
                  },
                ],
              },
              {
                key: InvoiceType.NFS,
                permissions: [Authorities.FISCAL_INVOICE_VIEW],
                component: InvoiceNFPage,
                name: 'layout.menu.fiscal.invoice.createNFSe',
                exact: true,
                routes: [
                  {
                    key: ':invoiceId',
                    permissions: [
                      Authorities.FISCAL_INVOICE_VIEW,
                      Authorities.FISCAL_INVOICE_EDIT,
                    ],
                    component: InvoiceNFSeDetailsPage,
                    name: 'layout.menu.fiscal.invoice.detailsNFSe',
                    routes: [
                      {
                        key: 'datas',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceEditGeneralPage,
                        name: 'layout.menu.fiscal.invoice.createNFSe.datasNFSe',
                        exact: true,
                      },
                      {
                        key: 'recipient',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceRecipientPage,
                        name: 'layout.menu.fiscal.invoice.create.recipient',
                        exact: true,
                      },
                      {
                        key: 'noteItens',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceNoteItensPage,
                        name: 'layout.menu.movement.fiscalReport.invoiceNoteItems',
                        exact: true,
                        routes: [
                          {
                            key: 'createServiceInvoice/service',
                            permissions: [
                              Authorities.FISCAL_INVOICE_VIEW,
                              Authorities.FISCAL_INVOICE_EDIT,
                            ],
                            component: InvoiceNoteItemServiceForm,
                            name: 'purchases.details.itemsPurchase.selectService',
                            exact: true,
                          },
                          {
                            key: 'editeItemInvoice/part/:invoicePartId',
                            permissions: [
                              Authorities.FISCAL_INVOICE_VIEW,
                              Authorities.FISCAL_INVOICE_EDIT,
                            ],
                            component: InvoiceEditNoteItemsSelectPartForm,
                            name: 'purchases.details.itemsPurchase.selectService',
                            exact: true,
                          },
                        ],
                      },
                      {
                        key: 'installments',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceNfsInstallmentsPage,
                        name: 'layout.menu.movement.fiscalReport.invoiceNFSIntallments',
                        exact: true,
                      },
                      {
                        key: 'deductions',
                        permissions: [
                          Authorities.FISCAL_INVOICE_VIEW,
                          Authorities.FISCAL_INVOICE_EDIT,
                        ],
                        component: InvoiceNfsDeductionsPage,
                        name: 'layout.menu.movement.fiscalReport.invoiceDeductions',
                        exact: true,
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            key: 'manifestationRecipient',
            permissions: [Authorities.FISCAL_INVOICE_RECIPIENT_STATEMENT],
            component: ManifestationRecipientPage,
            name: 'layout.menu.fiscal.invoice.manifestationRecipient',
            menu: {
              icon: <></>,
            },
            exact: true,
          },
          {
            key: 'disableNumberingRange',
            component: DisableNumberingRangePage,
            name: 'layout.menu.fiscal.invoice.disableNumberingRange',
            menu: {
              icon: <></>,
            },
            exact: true,
          },
          // Segunda fase
          //
          {
            key: 'cfe',
            component: InvoiceCFeListPage,
            name: 'layout.menu.fiscal.invoice.cfe',
            exact: true,
            routes: [
              {
                key: `:invoiceId/:companyId`,
                permissions: [Authorities.FISCAL_COUPON_VIEW_DETAIL],
                component: () => (
                  <PageRedirect path="/app/fiscal/invoice/general" />
                ),
                name: 'layout.menu.fiscal.invoice.cfe.general',
                exact: true,
                routes: [
                  {
                    component: InvoiceCFeGeneralDataPage,
                    key: 'general',
                    permissions: [Authorities.FISCAL_COUPON_VIEW_DETAIL],
                    name: 'layout.menu.fiscal.invoice.cfe.general',
                    exact: true,
                  },
                  {
                    component: InvoiceCFeRecipientPage,
                    key: 'destination',
                    permissions: [Authorities.FISCAL_COUPON_VIEW_DETAIL],
                    name: 'layout.menu.fiscal.invoice.cfe.recipient',
                    exact: true,
                  },
                  {
                    component: InvoiceCFeItensPage,
                    key: 'items',
                    permissions: [Authorities.FISCAL_COUPON_VIEW_DETAIL],
                    name: 'layout.menu.fiscal.invoice.cfe.items',
                    exact: true,
                  },
                  {
                    component: InvoiceCFePaymentsMethodPage,
                    key: 'payments',
                    permissions: [Authorities.FISCAL_COUPON_VIEW_DETAIL],
                    name: 'layout.menu.fiscal.invoice.cfe.payments',
                    exact: true,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        key: 'history',
        name: 'layout.menu.history',
        component: () => null,
        menu: {
          icon: <></>,
        },
        routes: [
          {
            key: 'vehiclesHistory',
            exact: true,
            component: VehiclesHistoryPage,
            name: 'layout.menu.vehicleHistory',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: ':licensePlate',
                exact: true,
                component: VehicleHistoryDetailPage,
                name: 'layout.menu.vehicleHistory',
                routes: [
                  {
                    key: 'detail',
                    component: VehicleHistoryDetailPage,
                    name: 'layout.menu.vehicleHistory',
                  },
                ],
              },
            ],
          },
          {
            key: 'plateHistory',
            exact: true,
            component: VehiclePlateHistoryPage,
            name: 'layout.menu.plateHistory',
          },
          {
            key: 'emailHistory',
            exact: true,
            component: EmailHistoryPage,
            name: 'layout.menu.emailHistory',
            menu: {
              icon: <></>,
            },
          },
        ],
      },

      {
        key: 'managementCharts',
        name: 'layout.menu.managementCharts',
        component: ManagementChartsPage,
        permissions: [Authorities.DEFAULT_MANAGERIAL_GRAPHICS],
        menu: {
          icon: <></>,
        },
        routes: [
          {
            key: 'financial',
            exact: true,
            component: FinancialChartsPage,
            name: 'layout.menu.financial',
            permissions: [Authorities.DEFAULT_MANAGERIAL_GRAPHICS],
          },
          {
            key: 'sales',
            exact: true,
            component: SaleChartsPage,
            name: 'layout.menu.sales',
            permissions: [Authorities.DEFAULT_MANAGERIAL_GRAPHICS],
          },
          {
            key: 'invoicing',
            exact: true,
            component: InvoicingChartsPage,
            name: 'layout.menu.invoicing',
            permissions: [Authorities.DEFAULT_MANAGERIAL_GRAPHICS],
          },
        ],
      },

      {
        key: 'schedules',
        name: 'layout.menu.schedules',
        component: SchedulePage,
        permissions: [Authorities.SHEDULE_EVERYTHING_VIEW],
        menu: {
          icon: <></>,
        },
        routes: [
          {
            key: 'kanban',
            exact: true,
            component: ScheduleKanbanPage,
            name: 'layout.menu.schedules.courtyard',
            permissions: [Authorities.SHEDULE_EVERYTHING_VIEW],
          },
          {
            key: 'accompaniment',
            exact: true,
            component: ScheduleAccompanimentPage,
            name: 'layout.menu.schedules.accompaniment',
            permissions: [Authorities.SHEDULE_EVERYTHING_VIEW],
          },
        ],
      },
      {
        key: 'informative',
        permissions: [Authorities.DEFAULT_INFORMATIVE],
        component: InformativePage,
        name: 'layout.menu.informative',
        exact: true,
        routes: [
          {
            key: 'create',
            permissions: [Authorities.MESSAGE_CREATE],
            name: 'layout.menu.workshopInformation',
            component: CreateInformativePage,
          },
          {
            key: ':informativeId',
            permissions: [Authorities.MESSAGE_READ],
            name: 'layout.menu.newsletterDetails',
            component: InformativeDetailsPage,
          },
        ],
      },
      {
        key: 'reports',
        component: () => null,
        name: 'layout.menu.reports',
        menu: {
          icon: <></>,
        },
        routes: [
          {
            key: 'movements',
            component: MovementReportsPage,
            name: 'layout.menu.reports.movement',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'workOrders',
                name: 'layout.menu.movement.workOrders',
                component: MovementWorkOrdersReportsPage,
                permissions: [
                  Authorities.REPORT_VIEW_MOVIMENTATION_WORKORDER_REPORTS,
                ],
                exact: true,
              },
              {
                key: 'dailyMovement',
                name: 'layout.menu.movement.dailyMovement',
                component: DailyMovementReportsPage,
                permissions: [Authorities.REPORT_REPORTS],
                exact: true,
              },
              {
                key: 'directSale',
                name: 'layout.menu.movement.directSale',
                component: MovementDirectSalePage,
                permissions: [Authorities.REPORT_VIEW_DIRECT_SALES_REPORTS],
                exact: true,
              },
              {
                key: 'osXFinancial',
                name: 'layout.menu.movement.osXFinancial',
                component: MovementOsXFinancialPage,
                exact: true,
                permissions: [
                  Authorities.REPORT_VIEW_MOVIMENTATION_WORKORDER_REPORTS,
                ],
              },
              {
                key: 'osXInvoice',
                name: 'layout.menu.movement.osXInvoice',
                component: MovementOsXInvoicePage,
                exact: true,
                permissions: [
                  Authorities.REPORT_VIEW_MOVIMENTATION_WORKORDER_REPORTS,
                ],
              },
              {
                key: 'directSaleXFinancial',
                name: 'layout.menu.movement.directSaleXFinancial',
                component: MovementDirectSaleXFinancialPage,
                permissions: [Authorities.REPORT_VIEW_DIRECT_SALES_REPORTS],
                exact: true,
              },
              {
                key: 'futureServices',
                name: 'layout.menu.movement.futureServices',
                component: MovementFutureServicesPage,
                permissions: [Authorities.REPORT_REPORTS],
                exact: true,
              },
              {
                key: 'customerWithout',
                name: 'layout.menu.movement.customerWithoutMovement',
                component: MovementCustomerWithoutMovementPage,
                permissions: [Authorities.REPORT_REPORTS],
                exact: true,
              },
              {
                key: 'vehicleWithoutMovement',
                name: 'layout.menu.movement.vehicleWithoutMovement',
                component: MovementVehicleWithoutMovementPage,
                permissions: [Authorities.REPORT_REPORTS],
                exact: true,
              },
              {
                key: 'abcCurve',
                name: 'layout.menu.movement.abcCurve',
                component: MovementAbcCurvePage,
                permissions: [Authorities.REPORT_VIEW_ABC_CURVE],
                exact: true,
              },
            ],
          },
          {
            key: 'reportsPurchases',
            name: 'layout.menu.reports.purchases',
            component: ReportsPurchasesPage,
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'purchases',
                name: 'layout.menu.reports.purchases',
                component: PurchasesReportsPage,
                permissions: [Authorities.REPORT_VIEW_PURCHASE_REPORTS],
                exact: true,
              },
              {
                key: 'returnedPurchases',
                name: 'layout.menu.reports.returnedPurchases',
                component: ReturnedPurchasesReportsPage,
                permissions: [Authorities.REPORT_VIEW_PURCHASE_REPORTS],
                exact: true,
              },
              {
                key: 'quotation',
                name: 'layout.menu.reports.purchases.quotation',
                component: PurchasesQuotationPage,
                permissions: [Authorities.REPORT_VIEW_PURCHASE_REPORTS],
                exact: true,
              },
              {
                key: 'abcCurve',
                name: 'layout.menu.reports.purchases.AbcCurve',
                permissions: [Authorities.REPORT_VIEW_PURCHASE_REPORTS],
                component: PurchasesAbcCurvePage,
                exact: true,
              },
            ],
          },
          {
            key: 'stock',
            component: StockReportsPage,
            name: 'layout.menu.reports.stock',
            exact: true,
            menu: { icon: <></> },
            routes: [
              {
                key: 'ABCAnalysis',
                name: 'layout.menu.stock.ABCAnalysis',
                component: ABCAnalysisPage,
                permissions: [Authorities.REPORT_INVENTORY_VIEW],
              },
              {
                key: 'deliveryOfMaterials',
                name: 'layout.menu.stock.deliveryOfMaterials',
                component: StockDeliveryOfMaterialsPage,
                permissions: [Authorities.REPORT_INVENTORY_VIEW],
              },
              {
                key: 'consolidated',
                name: 'layout.menu.stock.consolidated',
                component: ConsolidatedPage,
                permissions: [Authorities.REPORT_INVENTORY_VIEW],
                exact: true,
              },
              {
                key: 'minimumStock',
                name: 'layout.menu.stock.minimumStock',
                component: MinimumStockPage,
                permissions: [Authorities.REPORT_INVENTORY_VIEW],
                exact: true,
              },
            ],
          },
          {
            key: 'financial',
            component: FinancialReportsPage,
            name: 'layout.menu.reports.financial',
            exact: true,
            menu: { icon: <></> },
            routes: [
              {
                key: 'billsToPay',
                name: 'layout.menu.financial.billsToPay',
                component: FinancialBillsToPayPage,
                exact: true,
                permissions: [Authorities.REPORT_VIEW_ACCOUNTS_PAYABLE_REPORTS],
              },
              {
                key: 'billsToReceive',
                name: 'layout.menu.financial.billsToReceive',
                component: FinancialBillsToReceivePage,
                permissions: [
                  Authorities.REPORT_VIEW_ACCOUNTS_RECEIVABLE_REPORTS,
                ],
              },
              {
                key: 'balancete',
                name: 'layout.menu.financial.balancete',
                component: FinancialBalancetePage,
                permissions: [Authorities.REPORT_VIEW_BALANCE],
                exact: true,
              },
              {
                key: 'cashFlow',
                name: 'layout.menu.financial.cashFlow',
                component: FinancialCashFlowPage,
                permissions: [Authorities.BANKING_ENTRIES_CASH_MOVEMENT_REPORT],
                exact: true,
              },
              {
                key: 'dre',
                name: 'layout.menu.financial.dre',
                component: FinancialDrePage,
                permissions: [Authorities.REPORT_DRE_VIEW],
                exact: true,
              },
              {
                key: 'bankSlip',
                name: 'layout.menu.financial.bankSlip',
                permissions: [Authorities.REPORT_BANK_SLIP_VIEW],
                component: FinancialBankSlip,
                exact: true,
              },
            ],
          },
          {
            key: 'commission',
            component: CommissionReportsPage,
            name: 'layout.menu.reports.commission',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'byMoviments',
                name: 'layout.menu.movement.byMovement',
                component: CommissionByMovimentsPage,
                permissions: [Authorities.REPORT_COMMISSION_VIEW],
                exact: true,
              },
              {
                key: 'byFinancial',
                name: 'layout.menu.movement.byFinancial',
                component: CommissionByFinancialPage,
                permissions: [Authorities.REPORT_COMMISSION_VIEW],
                exact: true,
              },
            ],
          },
          {
            key: 'productive',
            name: 'layout.menu.reports.productive',
            component: ProductiveReportsPage,
            exact: true,
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'hoursSold',
                name: 'layout.menu.productive.hoursSold',
                permissions: [Authorities.REPORT_PRODUCTIVE_VIEW],
                component: ProductiveHoursSoldPage,
                exact: true,
              },
              {
                key: 'hourCost',
                name: 'layout.menu.productive.hoursCost',
                permissions: [Authorities.REPORT_PRODUCTIVE_VIEW],
                component: ProductiveHoursCostPage,
                exact: true,
              },
            ],
          },
          {
            key: 'managerial',
            name: 'layout.menu.reports.managerial',
            exact: true,
            component: ManagerialReportsPage,
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'invoicing',
                name: 'layout.menu.managerial.invoicing',
                exact: true,
                component: ManagerialInvoicingPage,
                permissions: [Authorities.REPORT_VIEW_MANAGERIAL_REPORTS],
              },
              {
                key: 'cost',
                name: 'layout.menu.managerial.cost',
                exact: true,
                component: ManagerialCostPage,
                permissions: [Authorities.REPORT_VIEW_MANAGERIAL_REPORTS],
              },
              {
                key: 'audit',
                name: 'layout.menu.managerial.audit',
                exact: true,
                component: ManagerialAuditPage,
                permissions: [Authorities.REPORT_VIEW_MANAGERIAL_REPORTS],
              },
              // {
              //   key: 'repeatedVehicles',
              //   name: 'layout.menu.managerial.repeatedVehicles',
              //   exact: true,
              //   component: ManagerialRepeatedVehiclesPage,
              //   permissions: [Authorities.REPORT_VIEW_MANAGERIAL_REPORTS],
              // },
            ],
          },
          {
            key: 'fiscalReport',
            component: FiscalReport,
            name: 'layout.menu.movement.fiscalReport',
            menu: {
              icon: <></>,
            },
            routes: [
              {
                key: 'invoice',
                name: 'layout.menu.movement.fiscalReport.invoice',
                component: FiscalInvoicePage,
                permissions: [Authorities.REPORT_VIEW_INVOICE_REPORTS],
                exact: true,
              },
              {
                key: 'salesByCST',
                name: 'layout.menu.movement.fiscalReport.salesByCST',
                permissions: [Authorities.REPORT_REPORTS],
                component: SalesByCST,
                exact: true,
              },
            ],
          },
          {
            key: 'yardManagement',
            name: 'layout.menu.reports.yardManagement',
            exact: true,
            component: YardManagementReportPage,
            menu: { icon: <></> },
          },
        ],
      },

      {
        key: 'notifications',
        permissions: [
          Authorities.CONFIGURATION_INFORMATIVE_NOTIFICATION_DISPLAY,
        ],
        component: NotificationsPage,
        name: 'layout.menu.notifications',
        exact: true,
        routes: [
          {
            key: 'create',
            exact: true,
            component: NotificationsCreatePage,
            name: 'layout.menu.notifications.create',
          },
        ],
      },

      {
        key: 'configProfile',
        component: ConfigsProfilePage,
        name: 'layout.menu.settings',
        routes: [
          {
            key: 'account',
            exact: true,
            component: AccountPage,
            name: 'layout.menu.settings.account',
          },
          {
            key: 'emailSettingsProfile',
            exact: true,
            component: EmailSettingsProfilePage,
            name: 'layout.menu.settings.emailUserSettings',
          },
          {
            key: 'parts',
            exact: true,
            component: PartsConfigurationPage,
            name: 'layout.menu.settings.partsConfiguration',
          },
          {
            key: 'workorders',
            exact: true,
            component: WorkorderConfigurationPage,
            name: 'layout.menu.settings.workorderConfiguration',
          },
          {
            key: 'financial',
            exact: true,
            component: FinancialConfigurationPage,
            name: 'layout.menu.settings.financialConfiguration',
          },
          {
            key: 'linkingAccounts',
            exact: true,
            component: LinkingAccountsPage,
            name: 'layout.menu.settings.linkingAccounts',
            permissions: [Authorities.CONFIGURATION_USER_ACCOUNT_AMAZON],
          },
        ],
      },

      {
        key: 'settings',
        component: SettingsPage,
        name: 'layout.menu.settings',
        permissions: [Authorities.CONFIGURATION_MATRIX_SETTINGS],
        routes: [
          {
            key: 'emailSettings',
            exact: true,
            component: EmailSettingsPage,
            name: 'layout.menu.settings.emailSettings',
            permissions: [
              Authorities.CONFIGURATION_MATRIX_SETTINGS,
              Authorities.CONFIGURATION_USER_EDIT_SYSTEM_SETTINGS,
            ],
          },
          {
            key: 'passwordSettings',
            exact: true,
            component: PasswordSettingsPage,
            name: 'layout.menu.settings.passwordSettings',
            permissions: [Authorities.CONFIGURATION_MATRIX_SETTINGS],
          },
          {
            key: 'registrySettings',
            exact: true,
            component: RegistrationsSettingsPage,
            name: 'layout.menu.settings.registrations',
            permissions: [Authorities.CONFIGURATION_MATRIX_SETTINGS],
          },
          {
            key: 'movementSettings',
            exact: true,
            component: MovementsSettingsPage,
            name: 'layout.menu.settings.movements',
            permissions: [Authorities.CONFIGURATION_MATRIX_SETTINGS],
          },
          {
            key: 'reportSettings',
            exact: true,
            component: ReportSettingsPage,
            name: 'layout.menu.settings.reports',
            permissions: [Authorities.CONFIGURATION_MATRIX_SETTINGS],
          },
          {
            key: 'crmSettings',
            exact: true,
            component: CrmSettingsPage,
            name: 'layout.menu.settings.crm',
            permissions: [
              Authorities.CONFIGURATION_MATRIX_SETTINGS,
              Authorities.CONFIGURATION_USER_MATRIX_CRM_SETTINGS_READ,
            ],
          },
          {
            key: 'emailSettingsCrm',
            exact: true,
            component: EmailSettingsCrmPage,
            name: 'layout.menu.settings.emailSettingsCrm',
            permissions: [
              Authorities.CONFIGURATION_MATRIX_SETTINGS,
              Authorities.CONFIGURATION_USER_MATRIX_CRM_SETTINGS_READ,
            ],
          },
          {
            key: 'profiles',
            exact: true,
            component: ProfilesPage,
            name: 'layout.menu.settings.profiles',
            permissions: [
              Authorities.CONFIGURATION_MATRIX_SETTINGS,
              Authorities.PROFILE_READ,
            ],
            routes: [
              {
                key: 'create',
                component: CreateProfilePage,
                name: 'layout.menu.settings.profiles.create',
                permissions: [
                  Authorities.CONFIGURATION_MATRIX_SETTINGS,
                  Authorities.PROFILE_CREATE,
                ],
              },
              {
                key: ':profileId',
                component: ProfileDetailsPage,
                name: 'layout.menu.settings.profiles.details',
                permissions: [
                  Authorities.CONFIGURATION_MATRIX_SETTINGS,
                  Authorities.PROFILE_READ,
                ],
              },
            ],
          },
          {
            key: 'users',
            exact: true,
            component: UsersPage,
            name: 'layout.menu.settings.users',
            permissions: [
              Authorities.CONFIGURATION_MATRIX_SETTINGS,
              Authorities.CONFIGURATION_USER_VIEW_USERS,
            ],
          },
          {
            key: 'fiscal',
            exact: true,
            component: SettingsFiscalPage,
            name: 'layout.menu.settings.fiscal',
            permissions: [
              Authorities.CONFIGURATION_MATRIX_SETTINGS,
              Authorities.CONFIGURATION_USER_INVOICE_SETTINGS_READ,
            ],
          },
          {
            key: 'whatsappTemplates',
            exact: true,
            component: WhatsappTemplates,
            name: 'layout.menu.settings.whatsapp.templates',
            permissions: [Authorities.CONFIGURATION_MATRIX_SETTINGS],
          },
          {
            key: 'integrations',
            exact: true,
            component: IntegrationsPage,
            name: 'layout.menu.settings.integrations',
          },
          {
            key: 'tagsWorkOrder',
            exact: true,
            component: TagsWorkOrderPage,
            name: 'layout.menu.settings.tagsWorkOrder',
          },
          {
            key: 'statusWorkOrder',
            exact: true,
            component: StatusWorkOrderPage,
            name: 'layout.menu.settings.statusWorkOrder',
          },
          {
            key: 'tagsDirectSale',
            exact: true,
            component: TagsDirectSalePage,
            name: 'layout.menu.settings.tagsdirectSale',
          },
          {
            key: 'financial',
            exact: true,
            component: FinancialSettingsPage,
            name: 'layout.menu.settings.financial',
          },
          {
            key: 'customer',
            exact: true,
            component: CustomerSettingsPage,
            name: 'layout.menu.settings.customer',
          },
        ],
      },
    ],
  },
  {
    key: 'expired',
    exact: true,
    component: ExpiredPage,
    name: 'expired',
  },
  {
    key: 'helpCenter',
    name: 'helpCenter',
    component: HelpCenterHomePage,
    exact: true,
    routes: [
      {
        key: ':helpAreaId',
        exact: true,
        component: HelpCenterHelpAreaPage,
        routes: [
          {
            exact: true,
            key: ':helpItemId',
            component: HelpCenterHelpItemPage,
          },
        ],
      },
    ],
  },
  {
    key: 'callback',
    component: LoginCallbackPage,
    name: 'LoginCallback',
    exact: true,
  },
  {
    key: 'callback/amazon',
    component: AmazonLoginPage,
    name: 'CallbackAmazonLogin',
    exact: true,
  },
  {
    key: '403',
    exact: true,
    component: ForbiddenPage,
    name: 'Forbidden',
  },
  {
    key: '401',
    exact: true,
    component: UnauthorizedPage,
    name: 'Forbidden',
  },
  {
    key: '404',
    exact: true,
    component: NotFoundPage,
    name: 'NotFound',
  },
  {
    key: 'privacyPolicy',
    exact: true,
    component: PrivacyPolicyPage,
    name: 'PrivacyPolicy',
  },
  {
    key: 'crm-quiz/:requestCode',
    exact: true,
    component: CrmQuizPage,
    name: 'CrmQuiz',
  },
  {
    key: 'account/validateEmail/:code',
    exact: true,
    component: AccountValidatePage,
    name: 'validateAccount',
  },
  {
    key: 'publicReports',
    component: <></>,
    name: 'Reports',
    routes: [
      {
        key: 'checklist',
        component: ChecklistReport,
        exact: true,
      },
    ],
  },
  {
    key: 'r',
    component: <></>,
    name: 'Reports',
    routes: [
      {
        key: 'checklist',
        component: ChecklistReport,
        exact: true,
      },
      {
        key: 'c/checklist',
        component: CustomerChecklistReport,
        exact: true,
      },
      {
        key: 'parts/:processId',
        component: PartsReport,
        exact: true,
      },
      {
        key: 'OS/:guid',
        component: PublicWorkOrderComplement,
        exact: true,
      },
      {
        key: 'reviewEtiquette/:guid',
        component: PublicWorkOrderReviewEtiquette,
        exact: true,
      },
      {
        key: 'bank-slip',
        component: BankSlipReportPublic,
        exact: true,
      },
    ],
  },
  {
    key: 'privateReports',
    component: <></>,
    name: 'Reports',
    routes: [
      {
        key: 'itemsByQuotation',
        component: PrivateQuatationReportsItemsByQuotation,
        exact: true,
      },
      {
        key: 'supplierWinners',
        component: PrivateQuatationReportsSupplierWinners,
        exact: true,
      },
      {
        key: 'itemsSuppliers',
        component: PrivateQuatationReportsItemsSuppliers,
        exact: true,
      },
      {
        key: 'materialDelivery',
        component: PrivateReportMaterialDelivery,
        exact: true,
      },
      {
        key: 'materialReturn',
        component: PrivateReportMaterialReturn,
        exact: true,
      },
      {
        key: 'checklistEmpty',
        component: PrivateReportChecklistEmpty,
        exact: true,
      },
      {
        key: 'employeeCommissions',
        component: ReportCommissionByEmployeePage,
        exact: true,
      },
      {
        key: 'inventory',
        component: PrivateInventory,
        exact: true,
      },
      // {
      //   key: 'vehicleHistoryReport',
      //   component: VehicleHistoryReportPage,
      //   exact: true,
      // },
      {
        key: 'mechanicsRecord/:companyId',
        component: PrivateReportMechanicsRecord,
        exact: true,
      },
      {
        key: 'inspectionRecord/:companyId',
        component: InspectionRecord,
        exact: true,
      },
      {
        key: 'productTags',
        component: PrivateReportProductTags,
        exact: true,
      },
      {
        key: 'customerTags',
        component: PrivateReportCustomerTags,
        exact: true,
      },
      {
        key: 'purchaseItemTags',
        component: PrivateReportPurchaseItemTags,
        exact: true,
      },
      {
        key: 'receiptRecord/:companyId',
        component: PrivateReportReceiptRecord,
        exact: true,
      },
      { key: 'label-print/parts', component: PartsLabelPrintPage },
    ],
  },
  {
    key: 'companies',
    component: <></>,
    name: 'Companies',
    routes: [
      {
        key: 'activation/:activation_token',
        groupKey: 'public',
        component: ActivationHashPage,
        exact: true,
      },
    ],
  },
];

export default formatRoutes(routes);
